/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type * as Types from './schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export * from './schema';
const defaultOptions = {} as const;
export type TAddressFieldsFragment = {
  id: string;
  companyId: string;
  _version: number;
  _deleted: boolean | null;
  address1: string | null;
  address2: string | null;
  city: string | null;
  state: string | null;
  country: string | null;
  zipCode: string | null;
  parent: string | null;
  parentType: Types.TAddressParentTypes | null;
  useGoogleAddress: boolean | null;
  googleValidated: boolean | null;
  missingInfo: boolean | null;
  alert: string | null;
  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
};

export type TSkipAddressAlertMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TSkipAddressAlertMutation = {
  skipAddressAlert: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parent: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TPublicCompanyFieldsFragment = {
  id: string;
  name: string;
  subdomain: string;
  googleLoginEnabled: boolean | null;
  passwordLoginEnabled: boolean | null;
  configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
};

export type TCompanyFieldsFragment = {
  id: string;
  _version: number;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  name: string;
  accountManager: string | null;
  active: boolean | null;
  deliveryMethod: Types.TDeliveryMethod;
  subdomain: string;
  emailDomains: Array<string>;
  googleLoginEnabled: boolean | null;
  swag: string | null;
  legoActivated: boolean | null;
  companyWideLegoCustomization: string | null;
  customLego: boolean | null;
  legoColor: string | null;
  tissueColor: string;
  signAs: string | null;
  specialNote: string | null;
  startDate: string | null;
  endDate: string | null;
  employeeBirthdayActivated: boolean;
  employeeWorkAnniversaryActivated: boolean;
  employeeNewHireKitActivated: boolean;
  significantOtherBirthdayActivated: boolean;
  childBirthdayActivated: boolean;
  petBirthdayActivated: boolean;
  hasCustomOnboardBrick: boolean | null;
  workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
  configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parent: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TGetMyCompanyQueryVariables = Exact<{ [key: string]: never }>;

export type TGetMyCompanyQuery = {
  getMyCompany: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    name: string;
    accountManager: string | null;
    active: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    swag: string | null;
    legoActivated: boolean | null;
    companyWideLegoCustomization: string | null;
    customLego: boolean | null;
    legoColor: string | null;
    tissueColor: string;
    signAs: string | null;
    specialNote: string | null;
    startDate: string | null;
    endDate: string | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    hasCustomOnboardBrick: boolean | null;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TGetCompanyBySubdomainQueryVariables = Exact<{
  subdomain: string;
}>;

export type TGetCompanyBySubdomainQuery = {
  getCompanyBySubdomain: {
    id: string;
    name: string;
    subdomain: string;
    googleLoginEnabled: boolean | null;
    passwordLoginEnabled: boolean | null;
    configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
  } | null;
};

export type TOnCompanyChangedSubscriptionVariables = Exact<{
  id: string;
}>;

export type TOnCompanyChangedSubscription = {
  onCompanyChanged: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    name: string;
    accountManager: string | null;
    active: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    swag: string | null;
    legoActivated: boolean | null;
    companyWideLegoCustomization: string | null;
    customLego: boolean | null;
    legoColor: string | null;
    tissueColor: string;
    signAs: string | null;
    specialNote: string | null;
    startDate: string | null;
    endDate: string | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    hasCustomOnboardBrick: boolean | null;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TRefreshCompanyEmployeeCountMutationVariables = Exact<{
  id: string;
}>;

export type TRefreshCompanyEmployeeCountMutation = { refreshCompanyEmployeeCount: { id: string; _version: number; employeeCount: number | null } | null };

export type TContactFieldsFragment = { name: string | null; email: string | null; phoneNumber: string | null };

export type TDependantFieldsFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  companyId: string;
  employeeId: string;
  type: Types.TDependantType;
  petType: string | null;
  firstName: string | null;
  preferredFirstName: string | null;
  lastName: string | null;
  fullName: string | null;
  birthDate: string | null;
  foodPreferences: string | null;
  donateBirthdayGift: boolean | null;
};

export type TDependantFieldsHydratedFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  companyId: string;
  employeeId: string;
  type: Types.TDependantType;
  petType: string | null;
  firstName: string | null;
  preferredFirstName: string | null;
  lastName: string | null;
  fullName: string | null;
  birthDate: string | null;
  foodPreferences: string | null;
  donateBirthdayGift: boolean | null;
  employee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TListCompanyDependantsQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListCompanyDependantsQuery = {
  listCompanyDependants: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      employeeId: string;
      type: Types.TDependantType;
      petType: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      fullName: string | null;
      birthDate: string | null;
      foodPreferences: string | null;
      donateBirthdayGift: boolean | null;
    } | null>;
  };
};

export type TListEmployeeDependantsQueryVariables = Exact<{
  companyId: string;
  employeeId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListEmployeeDependantsQuery = {
  listEmployeeDependants: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      employeeId: string;
      type: Types.TDependantType;
      petType: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      fullName: string | null;
      birthDate: string | null;
      foodPreferences: string | null;
      donateBirthdayGift: boolean | null;
    } | null>;
  };
};

export type TGetDependantQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetDependantQuery = {
  getDependant: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    employeeId: string;
    type: Types.TDependantType;
    petType: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    fullName: string | null;
    birthDate: string | null;
    foodPreferences: string | null;
    donateBirthdayGift: boolean | null;
  } | null;
};

export type TCreateDependantMutationVariables = Exact<{
  input: Types.TCreateDependantMutationInput;
}>;

export type TCreateDependantMutation = {
  createDependant: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    employeeId: string;
    type: Types.TDependantType;
    petType: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    fullName: string | null;
    birthDate: string | null;
    foodPreferences: string | null;
    donateBirthdayGift: boolean | null;
  } | null;
};

export type TUpdateDependantMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TUpdateDependantMutationInput;
}>;

export type TUpdateDependantMutation = {
  updateDependant: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    employeeId: string;
    type: Types.TDependantType;
    petType: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    fullName: string | null;
    birthDate: string | null;
    foodPreferences: string | null;
    donateBirthdayGift: boolean | null;
  } | null;
};

export type TDeleteDependantMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TDeleteDependantMutation = {
  deleteDependant: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    employeeId: string;
    type: Types.TDependantType;
    petType: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    fullName: string | null;
    birthDate: string | null;
    foodPreferences: string | null;
    donateBirthdayGift: boolean | null;
  } | null;
};

export type TOnCompanyDependantChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyDependantChangedSubscription = {
  onCompanyDependantChanged: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    employeeId: string;
    type: Types.TDependantType;
    petType: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    fullName: string | null;
    birthDate: string | null;
    foodPreferences: string | null;
    donateBirthdayGift: boolean | null;
  } | null;
};

export type TOnEmployeeDependantChangedSubscriptionVariables = Exact<{
  companyId: string;
  employeeId: string;
}>;

export type TOnEmployeeDependantChangedSubscription = {
  onEmployeeDependantChanged: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    employeeId: string;
    type: Types.TDependantType;
    petType: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    fullName: string | null;
    birthDate: string | null;
    foodPreferences: string | null;
    donateBirthdayGift: boolean | null;
  } | null;
};

export type TEmployeeFieldsFragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  companyId: string;
  fullName: string | null;
  email: string | null;
  birthDate: string | null;
  hireDate: string | null;
  officeId: string | null;
  isPaused: boolean | null;
  active: boolean | null;
  externalId: string | null;
  firstName: string | null;
  preferredFirstName: string | null;
  lastName: string | null;
  phoneNumber: Array<string | null> | null;
  foodPreferences: string | null;
  deliveryMethod: Types.TDeliveryMethod | null;
  customOnboardBrick: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  donateBirthdayGift: boolean | null;
  donateWorkAnniversaryGift: boolean | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parent: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  office: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TListCompanyEmployeesQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListCompanyEmployeesQuery = {
  listCompanyEmployees: {
    nextToken: string | null;
    items: Array<{
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      fullName: string | null;
      email: string | null;
      birthDate: string | null;
      hireDate: string | null;
      officeId: string | null;
      isPaused: boolean | null;
      active: boolean | null;
      externalId: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      deliveryMethod: Types.TDeliveryMethod | null;
      customOnboardBrick: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null>;
  };
};

export type TGetEmployeeQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetEmployeeQuery = {
  getEmployee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TCreateEmployeeMutationVariables = Exact<{
  input: Types.TCreateEmployeeMutationInput;
}>;

export type TCreateEmployeeMutation = {
  createEmployee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TUpdateEmployeeMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TUpdateEmployeeMutationInput;
}>;

export type TUpdateEmployeeMutation = {
  updateEmployee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TDeleteEmployeeMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TDeleteEmployeeMutation = {
  deleteEmployee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TPauseEmployeeGiftsMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  fromDate?: string | null | undefined;
  toDate?: string | null | undefined;
}>;

export type TPauseEmployeeGiftsMutation = {
  pauseEmployeeGifts: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TUnpauseEmployeeGiftsMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TUnpauseEmployeeGiftsMutation = {
  unpauseEmployeeGifts: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TOnCompanyEmployeeChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyEmployeeChangedSubscription = {
  onCompanyEmployeeChanged: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TEventFieldsFragment = {
  id: string;
  companyId: string;
  eventDate: string;
  type: Types.TEventTypes;
  customType: string | null;
  age: number | null;
  oneOffSource: string | null;
  brickQuantity: number | null;
  brickSize: string | null;
  brickColor: string | null;
  brickText: string | null;
  deliveredAt: string | null;
  isPaused: boolean | null;
  wasPaused: boolean | null;
  notes: string | null;
  _version: number;
  _deleted: boolean | null;
  employee: { id: string; companyId: string; fullName: string | null } | null;
  recipient:
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        employeeId: string;
        type: Types.TDependantType;
        petType: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        fullName: string | null;
        birthDate: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        } | null;
      }
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      }
    | null;
};

export type TListCompanyUpcomingEventsQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListCompanyUpcomingEventsQuery = {
  listCompanyUpcomingEvents: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      eventDate: string;
      type: Types.TEventTypes;
      customType: string | null;
      age: number | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      deliveredAt: string | null;
      isPaused: boolean | null;
      wasPaused: boolean | null;
      notes: string | null;
      _version: number;
      _deleted: boolean | null;
      employee: { id: string; companyId: string; fullName: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null>;
  };
};

export type TGetEventQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetEventQuery = {
  getEvent: {
    id: string;
    companyId: string;
    eventDate: string;
    type: Types.TEventTypes;
    customType: string | null;
    age: number | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    deliveredAt: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
    notes: string | null;
    _version: number;
    _deleted: boolean | null;
    employee: { id: string; companyId: string; fullName: string | null } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          employeeId: string;
          type: Types.TDependantType;
          petType: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          fullName: string | null;
          birthDate: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        }
      | null;
  } | null;
};

export type TListClientOneOffEventsQueryVariables = Exact<{
  companyId: string;
  eventPage: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  includingLastDays?: number | null | undefined;
  includingNextDays?: number | null | undefined;
  filter?: Types.TFilterInput | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
  isScan?: boolean | null | undefined;
}>;

export type TListClientOneOffEventsQuery = {
  listClientOneOffEvents: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      eventDate: string;
      type: Types.TEventTypes;
      customType: string | null;
      age: number | null;
      oneOffSource: string | null;
      brickQuantity: number | null;
      brickSize: string | null;
      brickColor: string | null;
      brickText: string | null;
      deliveredAt: string | null;
      isPaused: boolean | null;
      wasPaused: boolean | null;
      notes: string | null;
      _version: number;
      _deleted: boolean | null;
      employee: { id: string; companyId: string; fullName: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null>;
  };
};

export type TCreateOneOffEventMutationVariables = Exact<{
  input: string;
}>;

export type TCreateOneOffEventMutation = { createOneOffEvent: { status: number; error: boolean; message: string; data: string | null } | null };

export type TOnCompanyEventChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyEventChangedSubscription = {
  onCompanyEventChanged: {
    id: string;
    companyId: string;
    eventDate: string;
    type: Types.TEventTypes;
    customType: string | null;
    age: number | null;
    oneOffSource: string | null;
    brickQuantity: number | null;
    brickSize: string | null;
    brickColor: string | null;
    brickText: string | null;
    deliveredAt: string | null;
    isPaused: boolean | null;
    wasPaused: boolean | null;
    notes: string | null;
    _version: number;
    _deleted: boolean | null;
    employee: { id: string; companyId: string; fullName: string | null } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          employeeId: string;
          type: Types.TDependantType;
          petType: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          fullName: string | null;
          birthDate: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        }
      | null;
  } | null;
};

export type TGiftEventFieldsFragment = { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null };

export type TBasicGiftFieldsFragment = {
  id: string;
  companyId: string;
  _version: number;
  _deleted: boolean | null;
  employeeId: string;
  status: Types.TGiftStatuses;
  notes: string | null;
  recipientData: string | null;
  type: Types.TGiftTypes;
  oneOffSource: string | null;
  brickColor: string | null;
  brickSize: string | null;
  brickQuantity: number | null;
  brickText: string | null;
};

export type TGiftFieldsFragment = {
  id: string;
  companyId: string;
  _version: number;
  _deleted: boolean | null;
  employeeId: string;
  status: Types.TGiftStatuses;
  notes: string | null;
  recipientData: string | null;
  type: Types.TGiftTypes;
  oneOffSource: string | null;
  brickColor: string | null;
  brickSize: string | null;
  brickQuantity: number | null;
  brickText: string | null;
  event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
  recipient:
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        employeeId: string;
        type: Types.TDependantType;
        petType: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        fullName: string | null;
        birthDate: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        } | null;
      }
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      }
    | null;
};

export type TGiftFieldsHydratedFragment = {
  id: string;
  companyId: string;
  _version: number;
  _deleted: boolean | null;
  employeeId: string;
  status: Types.TGiftStatuses;
  notes: string | null;
  recipientData: string | null;
  type: Types.TGiftTypes;
  oneOffSource: string | null;
  brickColor: string | null;
  brickSize: string | null;
  brickQuantity: number | null;
  brickText: string | null;
  company: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    name: string;
    accountManager: string | null;
    active: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    swag: string | null;
    legoActivated: boolean | null;
    companyWideLegoCustomization: string | null;
    customLego: boolean | null;
    legoColor: string | null;
    tissueColor: string;
    signAs: string | null;
    specialNote: string | null;
    startDate: string | null;
    endDate: string | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    hasCustomOnboardBrick: boolean | null;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  shipment: {
    id: string;
    companyId: string;
    _deleted: boolean | null;
    _version: number;
    name: string | null;
    status: Types.TShipmentStatuses;
    trackingNumber: string | null;
    trackingURL: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    notes: string | null;
    addressTypeIcon: string | null;
    readableAddressType: string | null;
    recipientName: string | null;
    label: { carrier: string } | null;
    gifts: {
      nextToken: string | null;
      items: Array<{
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        employeeId: string;
        status: Types.TGiftStatuses;
        notes: string | null;
        recipientData: string | null;
        type: Types.TGiftTypes;
        oneOffSource: string | null;
        brickColor: string | null;
        brickSize: string | null;
        brickQuantity: number | null;
        brickText: string | null;
        event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
        recipient:
          | {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              employeeId: string;
              type: Types.TDependantType;
              petType: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              fullName: string | null;
              birthDate: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                fullName: string | null;
                email: string | null;
                birthDate: string | null;
                hireDate: string | null;
                officeId: string | null;
                isPaused: boolean | null;
                active: boolean | null;
                externalId: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                phoneNumber: Array<string | null> | null;
                foodPreferences: string | null;
                deliveryMethod: Types.TDeliveryMethod | null;
                customOnboardBrick: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                donateBirthdayGift: boolean | null;
                donateWorkAnniversaryGift: boolean | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
                office: {
                  id: string;
                  active: boolean;
                  name: string;
                  legalName: string | null;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            }
          | null;
      } | null>;
    } | null;
  } | null;
  employee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parent: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
  recipient:
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        employeeId: string;
        type: Types.TDependantType;
        petType: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        fullName: string | null;
        birthDate: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        } | null;
      }
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      }
    | null;
};

export type TListEmployeeAndDependatsGiftsQueryVariables = Exact<{
  employeeId: string;
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListEmployeeAndDependatsGiftsQuery = {
  listEmployeeAndDependatsGifts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      employeeId: string;
      status: Types.TGiftStatuses;
      notes: string | null;
      recipientData: string | null;
      type: Types.TGiftTypes;
      oneOffSource: string | null;
      brickColor: string | null;
      brickSize: string | null;
      brickQuantity: number | null;
      brickText: string | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        name: string;
        accountManager: string | null;
        active: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        swag: string | null;
        legoActivated: boolean | null;
        companyWideLegoCustomization: string | null;
        customLego: boolean | null;
        legoColor: string | null;
        tissueColor: string;
        signAs: string | null;
        specialNote: string | null;
        startDate: string | null;
        endDate: string | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        hasCustomOnboardBrick: boolean | null;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      shipment: {
        id: string;
        companyId: string;
        _deleted: boolean | null;
        _version: number;
        name: string | null;
        status: Types.TShipmentStatuses;
        trackingNumber: string | null;
        trackingURL: string | null;
        actualShippingDate: string | null;
        shippingDate: string | null;
        notes: string | null;
        addressTypeIcon: string | null;
        readableAddressType: string | null;
        recipientName: string | null;
        label: { carrier: string } | null;
        gifts: {
          nextToken: string | null;
          items: Array<{
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            employeeId: string;
            status: Types.TGiftStatuses;
            notes: string | null;
            recipientData: string | null;
            type: Types.TGiftTypes;
            oneOffSource: string | null;
            brickColor: string | null;
            brickSize: string | null;
            brickQuantity: number | null;
            brickText: string | null;
            event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
            recipient:
              | {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  employeeId: string;
                  type: Types.TDependantType;
                  petType: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  fullName: string | null;
                  birthDate: string | null;
                  foodPreferences: string | null;
                  donateBirthdayGift: boolean | null;
                  employee: {
                    id: string;
                    _version: number | null;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    companyId: string;
                    fullName: string | null;
                    email: string | null;
                    birthDate: string | null;
                    hireDate: string | null;
                    officeId: string | null;
                    isPaused: boolean | null;
                    active: boolean | null;
                    externalId: string | null;
                    firstName: string | null;
                    preferredFirstName: string | null;
                    lastName: string | null;
                    phoneNumber: Array<string | null> | null;
                    foodPreferences: string | null;
                    deliveryMethod: Types.TDeliveryMethod | null;
                    customOnboardBrick: string | null;
                    tShirtSize: string | null;
                    sweaterSize: string | null;
                    donateBirthdayGift: boolean | null;
                    donateWorkAnniversaryGift: boolean | null;
                    pausePeriod: { fromDate: string; toDate: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                    office: {
                      id: string;
                      active: boolean;
                      name: string;
                      legalName: string | null;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      _lastChangedAt: number | null;
                      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                      address: {
                        id: string;
                        companyId: string;
                        _version: number;
                        _deleted: boolean | null;
                        address1: string | null;
                        address2: string | null;
                        city: string | null;
                        state: string | null;
                        country: string | null;
                        zipCode: string | null;
                        parent: string | null;
                        parentType: Types.TAddressParentTypes | null;
                        useGoogleAddress: boolean | null;
                        googleValidated: boolean | null;
                        missingInfo: boolean | null;
                        alert: string | null;
                        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                }
              | {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  fullName: string | null;
                  email: string | null;
                  birthDate: string | null;
                  hireDate: string | null;
                  officeId: string | null;
                  isPaused: boolean | null;
                  active: boolean | null;
                  externalId: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  phoneNumber: Array<string | null> | null;
                  foodPreferences: string | null;
                  deliveryMethod: Types.TDeliveryMethod | null;
                  customOnboardBrick: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  donateBirthdayGift: boolean | null;
                  donateWorkAnniversaryGift: boolean | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                  office: {
                    id: string;
                    active: boolean;
                    name: string;
                    legalName: string | null;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                  } | null;
                }
              | null;
          } | null>;
        } | null;
      } | null;
      employee: {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null>;
  };
};

export type TGetGiftQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetGiftQuery = {
  getGift: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    employeeId: string;
    status: Types.TGiftStatuses;
    notes: string | null;
    recipientData: string | null;
    type: Types.TGiftTypes;
    oneOffSource: string | null;
    brickColor: string | null;
    brickSize: string | null;
    brickQuantity: number | null;
    brickText: string | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      name: string;
      accountManager: string | null;
      active: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      swag: string | null;
      legoActivated: boolean | null;
      companyWideLegoCustomization: string | null;
      customLego: boolean | null;
      legoColor: string | null;
      tissueColor: string;
      signAs: string | null;
      specialNote: string | null;
      startDate: string | null;
      endDate: string | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      hasCustomOnboardBrick: boolean | null;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    shipment: {
      id: string;
      companyId: string;
      _deleted: boolean | null;
      _version: number;
      name: string | null;
      status: Types.TShipmentStatuses;
      trackingNumber: string | null;
      trackingURL: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      notes: string | null;
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      label: { carrier: string } | null;
      gifts: {
        nextToken: string | null;
        items: Array<{
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          employeeId: string;
          status: Types.TGiftStatuses;
          notes: string | null;
          recipientData: string | null;
          type: Types.TGiftTypes;
          oneOffSource: string | null;
          brickColor: string | null;
          brickSize: string | null;
          brickQuantity: number | null;
          brickText: string | null;
          event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
          recipient:
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                employeeId: string;
                type: Types.TDependantType;
                petType: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                fullName: string | null;
                birthDate: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  fullName: string | null;
                  email: string | null;
                  birthDate: string | null;
                  hireDate: string | null;
                  officeId: string | null;
                  isPaused: boolean | null;
                  active: boolean | null;
                  externalId: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  phoneNumber: Array<string | null> | null;
                  foodPreferences: string | null;
                  deliveryMethod: Types.TDeliveryMethod | null;
                  customOnboardBrick: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  donateBirthdayGift: boolean | null;
                  donateWorkAnniversaryGift: boolean | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                  office: {
                    id: string;
                    active: boolean;
                    name: string;
                    legalName: string | null;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                fullName: string | null;
                email: string | null;
                birthDate: string | null;
                hireDate: string | null;
                officeId: string | null;
                isPaused: boolean | null;
                active: boolean | null;
                externalId: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                phoneNumber: Array<string | null> | null;
                foodPreferences: string | null;
                deliveryMethod: Types.TDeliveryMethod | null;
                customOnboardBrick: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                donateBirthdayGift: boolean | null;
                donateWorkAnniversaryGift: boolean | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
                office: {
                  id: string;
                  active: boolean;
                  name: string;
                  legalName: string | null;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                } | null;
              }
            | null;
        } | null>;
      } | null;
    } | null;
    employee: {
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      fullName: string | null;
      email: string | null;
      birthDate: string | null;
      hireDate: string | null;
      officeId: string | null;
      isPaused: boolean | null;
      active: boolean | null;
      externalId: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      deliveryMethod: Types.TDeliveryMethod | null;
      customOnboardBrick: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          employeeId: string;
          type: Types.TDependantType;
          petType: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          fullName: string | null;
          birthDate: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        }
      | null;
  } | null;
};

export type TOnCompanyEventGiftCreatedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyEventGiftCreatedSubscription = {
  onCompanyEventGiftCreated: {
    gift: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      employeeId: string;
      status: Types.TGiftStatuses;
      notes: string | null;
      recipientData: string | null;
      type: Types.TGiftTypes;
      oneOffSource: string | null;
      brickColor: string | null;
      brickSize: string | null;
      brickQuantity: number | null;
      brickText: string | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        name: string;
        accountManager: string | null;
        active: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        swag: string | null;
        legoActivated: boolean | null;
        companyWideLegoCustomization: string | null;
        customLego: boolean | null;
        legoColor: string | null;
        tissueColor: string;
        signAs: string | null;
        specialNote: string | null;
        startDate: string | null;
        endDate: string | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        hasCustomOnboardBrick: boolean | null;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      shipment: {
        id: string;
        companyId: string;
        _deleted: boolean | null;
        _version: number;
        name: string | null;
        status: Types.TShipmentStatuses;
        trackingNumber: string | null;
        trackingURL: string | null;
        actualShippingDate: string | null;
        shippingDate: string | null;
        notes: string | null;
        addressTypeIcon: string | null;
        readableAddressType: string | null;
        recipientName: string | null;
        label: { carrier: string } | null;
        gifts: {
          nextToken: string | null;
          items: Array<{
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            employeeId: string;
            status: Types.TGiftStatuses;
            notes: string | null;
            recipientData: string | null;
            type: Types.TGiftTypes;
            oneOffSource: string | null;
            brickColor: string | null;
            brickSize: string | null;
            brickQuantity: number | null;
            brickText: string | null;
            event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
            recipient:
              | {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  employeeId: string;
                  type: Types.TDependantType;
                  petType: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  fullName: string | null;
                  birthDate: string | null;
                  foodPreferences: string | null;
                  donateBirthdayGift: boolean | null;
                  employee: {
                    id: string;
                    _version: number | null;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    companyId: string;
                    fullName: string | null;
                    email: string | null;
                    birthDate: string | null;
                    hireDate: string | null;
                    officeId: string | null;
                    isPaused: boolean | null;
                    active: boolean | null;
                    externalId: string | null;
                    firstName: string | null;
                    preferredFirstName: string | null;
                    lastName: string | null;
                    phoneNumber: Array<string | null> | null;
                    foodPreferences: string | null;
                    deliveryMethod: Types.TDeliveryMethod | null;
                    customOnboardBrick: string | null;
                    tShirtSize: string | null;
                    sweaterSize: string | null;
                    donateBirthdayGift: boolean | null;
                    donateWorkAnniversaryGift: boolean | null;
                    pausePeriod: { fromDate: string; toDate: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                    office: {
                      id: string;
                      active: boolean;
                      name: string;
                      legalName: string | null;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      _lastChangedAt: number | null;
                      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                      address: {
                        id: string;
                        companyId: string;
                        _version: number;
                        _deleted: boolean | null;
                        address1: string | null;
                        address2: string | null;
                        city: string | null;
                        state: string | null;
                        country: string | null;
                        zipCode: string | null;
                        parent: string | null;
                        parentType: Types.TAddressParentTypes | null;
                        useGoogleAddress: boolean | null;
                        googleValidated: boolean | null;
                        missingInfo: boolean | null;
                        alert: string | null;
                        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                }
              | {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  fullName: string | null;
                  email: string | null;
                  birthDate: string | null;
                  hireDate: string | null;
                  officeId: string | null;
                  isPaused: boolean | null;
                  active: boolean | null;
                  externalId: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  phoneNumber: Array<string | null> | null;
                  foodPreferences: string | null;
                  deliveryMethod: Types.TDeliveryMethod | null;
                  customOnboardBrick: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  donateBirthdayGift: boolean | null;
                  donateWorkAnniversaryGift: boolean | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                  office: {
                    id: string;
                    active: boolean;
                    name: string;
                    legalName: string | null;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                  } | null;
                }
              | null;
          } | null>;
        } | null;
      } | null;
      employee: {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null;
  } | null;
};

export type TOnCompanyGiftRemovedFromGroupSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyGiftRemovedFromGroupSubscription = {
  onCompanyGiftRemovedFromGroup: {
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      employeeId: string;
      status: Types.TGiftStatuses;
      notes: string | null;
      recipientData: string | null;
      type: Types.TGiftTypes;
      oneOffSource: string | null;
      brickColor: string | null;
      brickSize: string | null;
      brickQuantity: number | null;
      brickText: string | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        name: string;
        accountManager: string | null;
        active: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        swag: string | null;
        legoActivated: boolean | null;
        companyWideLegoCustomization: string | null;
        customLego: boolean | null;
        legoColor: string | null;
        tissueColor: string;
        signAs: string | null;
        specialNote: string | null;
        startDate: string | null;
        endDate: string | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        hasCustomOnboardBrick: boolean | null;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      shipment: {
        id: string;
        companyId: string;
        _deleted: boolean | null;
        _version: number;
        name: string | null;
        status: Types.TShipmentStatuses;
        trackingNumber: string | null;
        trackingURL: string | null;
        actualShippingDate: string | null;
        shippingDate: string | null;
        notes: string | null;
        addressTypeIcon: string | null;
        readableAddressType: string | null;
        recipientName: string | null;
        label: { carrier: string } | null;
        gifts: {
          nextToken: string | null;
          items: Array<{
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            employeeId: string;
            status: Types.TGiftStatuses;
            notes: string | null;
            recipientData: string | null;
            type: Types.TGiftTypes;
            oneOffSource: string | null;
            brickColor: string | null;
            brickSize: string | null;
            brickQuantity: number | null;
            brickText: string | null;
            event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
            recipient:
              | {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  employeeId: string;
                  type: Types.TDependantType;
                  petType: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  fullName: string | null;
                  birthDate: string | null;
                  foodPreferences: string | null;
                  donateBirthdayGift: boolean | null;
                  employee: {
                    id: string;
                    _version: number | null;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    companyId: string;
                    fullName: string | null;
                    email: string | null;
                    birthDate: string | null;
                    hireDate: string | null;
                    officeId: string | null;
                    isPaused: boolean | null;
                    active: boolean | null;
                    externalId: string | null;
                    firstName: string | null;
                    preferredFirstName: string | null;
                    lastName: string | null;
                    phoneNumber: Array<string | null> | null;
                    foodPreferences: string | null;
                    deliveryMethod: Types.TDeliveryMethod | null;
                    customOnboardBrick: string | null;
                    tShirtSize: string | null;
                    sweaterSize: string | null;
                    donateBirthdayGift: boolean | null;
                    donateWorkAnniversaryGift: boolean | null;
                    pausePeriod: { fromDate: string; toDate: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                    office: {
                      id: string;
                      active: boolean;
                      name: string;
                      legalName: string | null;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      _lastChangedAt: number | null;
                      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                      address: {
                        id: string;
                        companyId: string;
                        _version: number;
                        _deleted: boolean | null;
                        address1: string | null;
                        address2: string | null;
                        city: string | null;
                        state: string | null;
                        country: string | null;
                        zipCode: string | null;
                        parent: string | null;
                        parentType: Types.TAddressParentTypes | null;
                        useGoogleAddress: boolean | null;
                        googleValidated: boolean | null;
                        missingInfo: boolean | null;
                        alert: string | null;
                        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                      } | null;
                    } | null;
                  } | null;
                }
              | {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  fullName: string | null;
                  email: string | null;
                  birthDate: string | null;
                  hireDate: string | null;
                  officeId: string | null;
                  isPaused: boolean | null;
                  active: boolean | null;
                  externalId: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  phoneNumber: Array<string | null> | null;
                  foodPreferences: string | null;
                  deliveryMethod: Types.TDeliveryMethod | null;
                  customOnboardBrick: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  donateBirthdayGift: boolean | null;
                  donateWorkAnniversaryGift: boolean | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                  office: {
                    id: string;
                    active: boolean;
                    name: string;
                    legalName: string | null;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                  } | null;
                }
              | null;
          } | null>;
        } | null;
      } | null;
      employee: {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type TOnCompanyGiftChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyGiftChangedSubscription = {
  onCompanyGiftChanged: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    employeeId: string;
    status: Types.TGiftStatuses;
    notes: string | null;
    recipientData: string | null;
    type: Types.TGiftTypes;
    oneOffSource: string | null;
    brickColor: string | null;
    brickSize: string | null;
    brickQuantity: number | null;
    brickText: string | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      name: string;
      accountManager: string | null;
      active: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      swag: string | null;
      legoActivated: boolean | null;
      companyWideLegoCustomization: string | null;
      customLego: boolean | null;
      legoColor: string | null;
      tissueColor: string;
      signAs: string | null;
      specialNote: string | null;
      startDate: string | null;
      endDate: string | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      hasCustomOnboardBrick: boolean | null;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    shipment: {
      id: string;
      companyId: string;
      _deleted: boolean | null;
      _version: number;
      name: string | null;
      status: Types.TShipmentStatuses;
      trackingNumber: string | null;
      trackingURL: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      notes: string | null;
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      label: { carrier: string } | null;
      gifts: {
        nextToken: string | null;
        items: Array<{
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          employeeId: string;
          status: Types.TGiftStatuses;
          notes: string | null;
          recipientData: string | null;
          type: Types.TGiftTypes;
          oneOffSource: string | null;
          brickColor: string | null;
          brickSize: string | null;
          brickQuantity: number | null;
          brickText: string | null;
          event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
          recipient:
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                employeeId: string;
                type: Types.TDependantType;
                petType: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                fullName: string | null;
                birthDate: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  fullName: string | null;
                  email: string | null;
                  birthDate: string | null;
                  hireDate: string | null;
                  officeId: string | null;
                  isPaused: boolean | null;
                  active: boolean | null;
                  externalId: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  phoneNumber: Array<string | null> | null;
                  foodPreferences: string | null;
                  deliveryMethod: Types.TDeliveryMethod | null;
                  customOnboardBrick: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  donateBirthdayGift: boolean | null;
                  donateWorkAnniversaryGift: boolean | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                  office: {
                    id: string;
                    active: boolean;
                    name: string;
                    legalName: string | null;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                fullName: string | null;
                email: string | null;
                birthDate: string | null;
                hireDate: string | null;
                officeId: string | null;
                isPaused: boolean | null;
                active: boolean | null;
                externalId: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                phoneNumber: Array<string | null> | null;
                foodPreferences: string | null;
                deliveryMethod: Types.TDeliveryMethod | null;
                customOnboardBrick: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                donateBirthdayGift: boolean | null;
                donateWorkAnniversaryGift: boolean | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
                office: {
                  id: string;
                  active: boolean;
                  name: string;
                  legalName: string | null;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                } | null;
              }
            | null;
        } | null>;
      } | null;
    } | null;
    employee: {
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      fullName: string | null;
      email: string | null;
      birthDate: string | null;
      hireDate: string | null;
      officeId: string | null;
      isPaused: boolean | null;
      active: boolean | null;
      externalId: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      deliveryMethod: Types.TDeliveryMethod | null;
      customOnboardBrick: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          employeeId: string;
          type: Types.TDependantType;
          petType: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          fullName: string | null;
          birthDate: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        }
      | null;
  } | null;
};

export type TOnEmployeeGiftChangedSubscriptionVariables = Exact<{
  employeeId: string;
  companyId: string;
}>;

export type TOnEmployeeGiftChangedSubscription = {
  onEmployeeGiftChanged: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    employeeId: string;
    status: Types.TGiftStatuses;
    notes: string | null;
    recipientData: string | null;
    type: Types.TGiftTypes;
    oneOffSource: string | null;
    brickColor: string | null;
    brickSize: string | null;
    brickQuantity: number | null;
    brickText: string | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      name: string;
      accountManager: string | null;
      active: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      swag: string | null;
      legoActivated: boolean | null;
      companyWideLegoCustomization: string | null;
      customLego: boolean | null;
      legoColor: string | null;
      tissueColor: string;
      signAs: string | null;
      specialNote: string | null;
      startDate: string | null;
      endDate: string | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      hasCustomOnboardBrick: boolean | null;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    shipment: {
      id: string;
      companyId: string;
      _deleted: boolean | null;
      _version: number;
      name: string | null;
      status: Types.TShipmentStatuses;
      trackingNumber: string | null;
      trackingURL: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      notes: string | null;
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      label: { carrier: string } | null;
      gifts: {
        nextToken: string | null;
        items: Array<{
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          employeeId: string;
          status: Types.TGiftStatuses;
          notes: string | null;
          recipientData: string | null;
          type: Types.TGiftTypes;
          oneOffSource: string | null;
          brickColor: string | null;
          brickSize: string | null;
          brickQuantity: number | null;
          brickText: string | null;
          event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
          recipient:
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                employeeId: string;
                type: Types.TDependantType;
                petType: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                fullName: string | null;
                birthDate: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  fullName: string | null;
                  email: string | null;
                  birthDate: string | null;
                  hireDate: string | null;
                  officeId: string | null;
                  isPaused: boolean | null;
                  active: boolean | null;
                  externalId: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  phoneNumber: Array<string | null> | null;
                  foodPreferences: string | null;
                  deliveryMethod: Types.TDeliveryMethod | null;
                  customOnboardBrick: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  donateBirthdayGift: boolean | null;
                  donateWorkAnniversaryGift: boolean | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                  office: {
                    id: string;
                    active: boolean;
                    name: string;
                    legalName: string | null;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                fullName: string | null;
                email: string | null;
                birthDate: string | null;
                hireDate: string | null;
                officeId: string | null;
                isPaused: boolean | null;
                active: boolean | null;
                externalId: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                phoneNumber: Array<string | null> | null;
                foodPreferences: string | null;
                deliveryMethod: Types.TDeliveryMethod | null;
                customOnboardBrick: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                donateBirthdayGift: boolean | null;
                donateWorkAnniversaryGift: boolean | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
                office: {
                  id: string;
                  active: boolean;
                  name: string;
                  legalName: string | null;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                } | null;
              }
            | null;
        } | null>;
      } | null;
    } | null;
    employee: {
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      fullName: string | null;
      email: string | null;
      birthDate: string | null;
      hireDate: string | null;
      officeId: string | null;
      isPaused: boolean | null;
      active: boolean | null;
      externalId: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      deliveryMethod: Types.TDeliveryMethod | null;
      customOnboardBrick: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          employeeId: string;
          type: Types.TDependantType;
          petType: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          fullName: string | null;
          birthDate: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        }
      | null;
  } | null;
};

export type TOfficeFieldsFragment = {
  id: string;
  active: boolean;
  name: string;
  legalName: string | null;
  companyId: string;
  _version: number;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parent: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
};

export type TListOfficesQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListOfficesQuery = {
  listOffices: {
    nextToken: string | null;
    items: Array<{
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null>;
  };
};

export type TGetOfficeQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetOfficeQuery = {
  getOffice: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TCreateOfficeMutationVariables = Exact<{
  input: Types.TCreateOfficeMutationInput;
}>;

export type TCreateOfficeMutation = {
  createOffice: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TUpdateOfficeMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
  input: Types.TUpdateOfficeMutationInput;
}>;

export type TUpdateOfficeMutation = {
  updateOffice: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TDeleteOfficeMutationVariables = Exact<{
  id: string;
  companyId: string;
  version: number;
}>;

export type TDeleteOfficeMutation = {
  deleteOffice: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TOnCompanyOfficeChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyOfficeChangedSubscription = {
  onCompanyOfficeChanged: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TRecipientFields_Dependant_Fragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  companyId: string;
  employeeId: string;
  type: Types.TDependantType;
  petType: string | null;
  firstName: string | null;
  preferredFirstName: string | null;
  lastName: string | null;
  fullName: string | null;
  birthDate: string | null;
  foodPreferences: string | null;
  donateBirthdayGift: boolean | null;
  employee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
};

export type TRecipientFields_Employee_Fragment = {
  id: string;
  _version: number | null;
  _deleted: boolean | null;
  _lastChangedAt: number | null;
  companyId: string;
  fullName: string | null;
  email: string | null;
  birthDate: string | null;
  hireDate: string | null;
  officeId: string | null;
  isPaused: boolean | null;
  active: boolean | null;
  externalId: string | null;
  firstName: string | null;
  preferredFirstName: string | null;
  lastName: string | null;
  phoneNumber: Array<string | null> | null;
  foodPreferences: string | null;
  deliveryMethod: Types.TDeliveryMethod | null;
  customOnboardBrick: string | null;
  tShirtSize: string | null;
  sweaterSize: string | null;
  donateBirthdayGift: boolean | null;
  donateWorkAnniversaryGift: boolean | null;
  pausePeriod: { fromDate: string; toDate: string | null } | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parent: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  office: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
};

export type TRecipientFieldsFragment = TRecipientFields_Dependant_Fragment | TRecipientFields_Employee_Fragment;

export type TShipmentFieldsFragment = {
  id: string;
  companyId: string;
  _deleted: boolean | null;
  _version: number;
  name: string | null;
  status: Types.TShipmentStatuses;
  trackingNumber: string | null;
  trackingURL: string | null;
  actualShippingDate: string | null;
  shippingDate: string | null;
  notes: string | null;
  addressTypeIcon: string | null;
  readableAddressType: string | null;
  recipientName: string | null;
  label: { carrier: string } | null;
  gifts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      employeeId: string;
      status: Types.TGiftStatuses;
      notes: string | null;
      recipientData: string | null;
      type: Types.TGiftTypes;
      oneOffSource: string | null;
      brickColor: string | null;
      brickSize: string | null;
      brickQuantity: number | null;
      brickText: string | null;
      event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type TShipmentFieldsHydratedFragment = {
  id: string;
  companyId: string;
  _deleted: boolean | null;
  _version: number;
  name: string | null;
  status: Types.TShipmentStatuses;
  trackingNumber: string | null;
  trackingURL: string | null;
  actualShippingDate: string | null;
  shippingDate: string | null;
  notes: string | null;
  addressTypeIcon: string | null;
  readableAddressType: string | null;
  recipientName: string | null;
  address: {
    id: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    address1: string | null;
    address2: string | null;
    city: string | null;
    state: string | null;
    country: string | null;
    zipCode: string | null;
    parent: string | null;
    parentType: Types.TAddressParentTypes | null;
    useGoogleAddress: boolean | null;
    googleValidated: boolean | null;
    missingInfo: boolean | null;
    alert: string | null;
    employee: {
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      fullName: string | null;
      email: string | null;
      birthDate: string | null;
      hireDate: string | null;
      officeId: string | null;
      isPaused: boolean | null;
      active: boolean | null;
      externalId: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      deliveryMethod: Types.TDeliveryMethod | null;
      customOnboardBrick: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      name: string;
      accountManager: string | null;
      active: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      swag: string | null;
      legoActivated: boolean | null;
      companyWideLegoCustomization: string | null;
      customLego: boolean | null;
      legoColor: string | null;
      tissueColor: string;
      signAs: string | null;
      specialNote: string | null;
      startDate: string | null;
      endDate: string | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      hasCustomOnboardBrick: boolean | null;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
  } | null;
  company: {
    id: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    name: string;
    accountManager: string | null;
    active: boolean | null;
    deliveryMethod: Types.TDeliveryMethod;
    subdomain: string;
    emailDomains: Array<string>;
    googleLoginEnabled: boolean | null;
    swag: string | null;
    legoActivated: boolean | null;
    companyWideLegoCustomization: string | null;
    customLego: boolean | null;
    legoColor: string | null;
    tissueColor: string;
    signAs: string | null;
    specialNote: string | null;
    startDate: string | null;
    endDate: string | null;
    employeeBirthdayActivated: boolean;
    employeeWorkAnniversaryActivated: boolean;
    employeeNewHireKitActivated: boolean;
    significantOtherBirthdayActivated: boolean;
    childBirthdayActivated: boolean;
    petBirthdayActivated: boolean;
    hasCustomOnboardBrick: boolean | null;
    workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
    configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  office: {
    id: string;
    active: boolean;
    name: string;
    legalName: string | null;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
  } | null;
  employee: {
    id: string;
    _version: number | null;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    companyId: string;
    fullName: string | null;
    email: string | null;
    birthDate: string | null;
    hireDate: string | null;
    officeId: string | null;
    isPaused: boolean | null;
    active: boolean | null;
    externalId: string | null;
    firstName: string | null;
    preferredFirstName: string | null;
    lastName: string | null;
    phoneNumber: Array<string | null> | null;
    foodPreferences: string | null;
    deliveryMethod: Types.TDeliveryMethod | null;
    customOnboardBrick: string | null;
    tShirtSize: string | null;
    sweaterSize: string | null;
    donateBirthdayGift: boolean | null;
    donateWorkAnniversaryGift: boolean | null;
    pausePeriod: { fromDate: string; toDate: string | null } | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
  } | null;
  recipient:
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        employeeId: string;
        type: Types.TDependantType;
        petType: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        fullName: string | null;
        birthDate: string | null;
        foodPreferences: string | null;
        donateBirthdayGift: boolean | null;
        employee: {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        } | null;
      }
    | {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      }
    | null;
  label: { carrier: string } | null;
  gifts: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      employeeId: string;
      status: Types.TGiftStatuses;
      notes: string | null;
      recipientData: string | null;
      type: Types.TGiftTypes;
      oneOffSource: string | null;
      brickColor: string | null;
      brickSize: string | null;
      brickQuantity: number | null;
      brickText: string | null;
      event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type TListShipmentsQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListShipmentsQuery = {
  listCompanyShipments: {
    nextToken: string | null;
    items: Array<{
      id: string;
      companyId: string;
      _deleted: boolean | null;
      _version: number;
      name: string | null;
      status: Types.TShipmentStatuses;
      trackingNumber: string | null;
      trackingURL: string | null;
      actualShippingDate: string | null;
      shippingDate: string | null;
      notes: string | null;
      addressTypeIcon: string | null;
      readableAddressType: string | null;
      recipientName: string | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        employee: {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
        company: {
          id: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          name: string;
          accountManager: string | null;
          active: boolean | null;
          deliveryMethod: Types.TDeliveryMethod;
          subdomain: string;
          emailDomains: Array<string>;
          googleLoginEnabled: boolean | null;
          swag: string | null;
          legoActivated: boolean | null;
          companyWideLegoCustomization: string | null;
          customLego: boolean | null;
          legoColor: string | null;
          tissueColor: string;
          signAs: string | null;
          specialNote: string | null;
          startDate: string | null;
          endDate: string | null;
          employeeBirthdayActivated: boolean;
          employeeWorkAnniversaryActivated: boolean;
          employeeNewHireKitActivated: boolean;
          significantOtherBirthdayActivated: boolean;
          childBirthdayActivated: boolean;
          petBirthdayActivated: boolean;
          hasCustomOnboardBrick: boolean | null;
          workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
          configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        name: string;
        accountManager: string | null;
        active: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        swag: string | null;
        legoActivated: boolean | null;
        companyWideLegoCustomization: string | null;
        customLego: boolean | null;
        legoColor: string | null;
        tissueColor: string;
        signAs: string | null;
        specialNote: string | null;
        startDate: string | null;
        endDate: string | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        hasCustomOnboardBrick: boolean | null;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      employee: {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
      label: { carrier: string } | null;
      gifts: {
        nextToken: string | null;
        items: Array<{
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          employeeId: string;
          status: Types.TGiftStatuses;
          notes: string | null;
          recipientData: string | null;
          type: Types.TGiftTypes;
          oneOffSource: string | null;
          brickColor: string | null;
          brickSize: string | null;
          brickQuantity: number | null;
          brickText: string | null;
          event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
          recipient:
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                employeeId: string;
                type: Types.TDependantType;
                petType: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                fullName: string | null;
                birthDate: string | null;
                foodPreferences: string | null;
                donateBirthdayGift: boolean | null;
                employee: {
                  id: string;
                  _version: number | null;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  companyId: string;
                  fullName: string | null;
                  email: string | null;
                  birthDate: string | null;
                  hireDate: string | null;
                  officeId: string | null;
                  isPaused: boolean | null;
                  active: boolean | null;
                  externalId: string | null;
                  firstName: string | null;
                  preferredFirstName: string | null;
                  lastName: string | null;
                  phoneNumber: Array<string | null> | null;
                  foodPreferences: string | null;
                  deliveryMethod: Types.TDeliveryMethod | null;
                  customOnboardBrick: string | null;
                  tShirtSize: string | null;
                  sweaterSize: string | null;
                  donateBirthdayGift: boolean | null;
                  donateWorkAnniversaryGift: boolean | null;
                  pausePeriod: { fromDate: string; toDate: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                  office: {
                    id: string;
                    active: boolean;
                    name: string;
                    legalName: string | null;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    _lastChangedAt: number | null;
                    contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                    address: {
                      id: string;
                      companyId: string;
                      _version: number;
                      _deleted: boolean | null;
                      address1: string | null;
                      address2: string | null;
                      city: string | null;
                      state: string | null;
                      country: string | null;
                      zipCode: string | null;
                      parent: string | null;
                      parentType: Types.TAddressParentTypes | null;
                      useGoogleAddress: boolean | null;
                      googleValidated: boolean | null;
                      missingInfo: boolean | null;
                      alert: string | null;
                      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                    } | null;
                  } | null;
                } | null;
              }
            | {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                fullName: string | null;
                email: string | null;
                birthDate: string | null;
                hireDate: string | null;
                officeId: string | null;
                isPaused: boolean | null;
                active: boolean | null;
                externalId: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                phoneNumber: Array<string | null> | null;
                foodPreferences: string | null;
                deliveryMethod: Types.TDeliveryMethod | null;
                customOnboardBrick: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                donateBirthdayGift: boolean | null;
                donateWorkAnniversaryGift: boolean | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
                office: {
                  id: string;
                  active: boolean;
                  name: string;
                  legalName: string | null;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                } | null;
              }
            | null;
        } | null>;
      } | null;
    } | null>;
  };
};

export type TGetShipmentQueryVariables = Exact<{
  id: string;
  companyId: string;
}>;

export type TGetShipmentQuery = {
  getShipment: {
    id: string;
    companyId: string;
    _deleted: boolean | null;
    _version: number;
    name: string | null;
    status: Types.TShipmentStatuses;
    trackingNumber: string | null;
    trackingURL: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    notes: string | null;
    addressTypeIcon: string | null;
    readableAddressType: string | null;
    recipientName: string | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      employee: {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        name: string;
        accountManager: string | null;
        active: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        swag: string | null;
        legoActivated: boolean | null;
        companyWideLegoCustomization: string | null;
        customLego: boolean | null;
        legoColor: string | null;
        tissueColor: string;
        signAs: string | null;
        specialNote: string | null;
        startDate: string | null;
        endDate: string | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        hasCustomOnboardBrick: boolean | null;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      name: string;
      accountManager: string | null;
      active: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      swag: string | null;
      legoActivated: boolean | null;
      companyWideLegoCustomization: string | null;
      customLego: boolean | null;
      legoColor: string | null;
      tissueColor: string;
      signAs: string | null;
      specialNote: string | null;
      startDate: string | null;
      endDate: string | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      hasCustomOnboardBrick: boolean | null;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    employee: {
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      fullName: string | null;
      email: string | null;
      birthDate: string | null;
      hireDate: string | null;
      officeId: string | null;
      isPaused: boolean | null;
      active: boolean | null;
      externalId: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      deliveryMethod: Types.TDeliveryMethod | null;
      customOnboardBrick: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          employeeId: string;
          type: Types.TDependantType;
          petType: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          fullName: string | null;
          birthDate: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        }
      | null;
    label: { carrier: string } | null;
    gifts: {
      nextToken: string | null;
      items: Array<{
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        employeeId: string;
        status: Types.TGiftStatuses;
        notes: string | null;
        recipientData: string | null;
        type: Types.TGiftTypes;
        oneOffSource: string | null;
        brickColor: string | null;
        brickSize: string | null;
        brickQuantity: number | null;
        brickText: string | null;
        event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
        recipient:
          | {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              employeeId: string;
              type: Types.TDependantType;
              petType: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              fullName: string | null;
              birthDate: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                fullName: string | null;
                email: string | null;
                birthDate: string | null;
                hireDate: string | null;
                officeId: string | null;
                isPaused: boolean | null;
                active: boolean | null;
                externalId: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                phoneNumber: Array<string | null> | null;
                foodPreferences: string | null;
                deliveryMethod: Types.TDeliveryMethod | null;
                customOnboardBrick: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                donateBirthdayGift: boolean | null;
                donateWorkAnniversaryGift: boolean | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
                office: {
                  id: string;
                  active: boolean;
                  name: string;
                  legalName: string | null;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            }
          | null;
      } | null>;
    } | null;
  } | null;
};

export type TOnCompanyShipmentChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyShipmentChangedSubscription = {
  onCompanyShipmentChanged: {
    id: string;
    companyId: string;
    _deleted: boolean | null;
    _version: number;
    name: string | null;
    status: Types.TShipmentStatuses;
    trackingNumber: string | null;
    trackingURL: string | null;
    actualShippingDate: string | null;
    shippingDate: string | null;
    notes: string | null;
    addressTypeIcon: string | null;
    readableAddressType: string | null;
    recipientName: string | null;
    address: {
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      address1: string | null;
      address2: string | null;
      city: string | null;
      state: string | null;
      country: string | null;
      zipCode: string | null;
      parent: string | null;
      parentType: Types.TAddressParentTypes | null;
      useGoogleAddress: boolean | null;
      googleValidated: boolean | null;
      missingInfo: boolean | null;
      alert: string | null;
      employee: {
        id: string;
        _version: number | null;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        companyId: string;
        fullName: string | null;
        email: string | null;
        birthDate: string | null;
        hireDate: string | null;
        officeId: string | null;
        isPaused: boolean | null;
        active: boolean | null;
        externalId: string | null;
        firstName: string | null;
        preferredFirstName: string | null;
        lastName: string | null;
        phoneNumber: Array<string | null> | null;
        foodPreferences: string | null;
        deliveryMethod: Types.TDeliveryMethod | null;
        customOnboardBrick: string | null;
        tShirtSize: string | null;
        sweaterSize: string | null;
        donateBirthdayGift: boolean | null;
        donateWorkAnniversaryGift: boolean | null;
        pausePeriod: { fromDate: string; toDate: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
        office: {
          id: string;
          active: boolean;
          name: string;
          legalName: string | null;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
        } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      company: {
        id: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        name: string;
        accountManager: string | null;
        active: boolean | null;
        deliveryMethod: Types.TDeliveryMethod;
        subdomain: string;
        emailDomains: Array<string>;
        googleLoginEnabled: boolean | null;
        swag: string | null;
        legoActivated: boolean | null;
        companyWideLegoCustomization: string | null;
        customLego: boolean | null;
        legoColor: string | null;
        tissueColor: string;
        signAs: string | null;
        specialNote: string | null;
        startDate: string | null;
        endDate: string | null;
        employeeBirthdayActivated: boolean;
        employeeWorkAnniversaryActivated: boolean;
        employeeNewHireKitActivated: boolean;
        significantOtherBirthdayActivated: boolean;
        childBirthdayActivated: boolean;
        petBirthdayActivated: boolean;
        hasCustomOnboardBrick: boolean | null;
        workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
        configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
      addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
    } | null;
    company: {
      id: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      name: string;
      accountManager: string | null;
      active: boolean | null;
      deliveryMethod: Types.TDeliveryMethod;
      subdomain: string;
      emailDomains: Array<string>;
      googleLoginEnabled: boolean | null;
      swag: string | null;
      legoActivated: boolean | null;
      companyWideLegoCustomization: string | null;
      customLego: boolean | null;
      legoColor: string | null;
      tissueColor: string;
      signAs: string | null;
      specialNote: string | null;
      startDate: string | null;
      endDate: string | null;
      employeeBirthdayActivated: boolean;
      employeeWorkAnniversaryActivated: boolean;
      employeeNewHireKitActivated: boolean;
      significantOtherBirthdayActivated: boolean;
      childBirthdayActivated: boolean;
      petBirthdayActivated: boolean;
      hasCustomOnboardBrick: boolean | null;
      workAnniversaryGiftVariation: Types.TWorkAnniversaryGiftVariations | null;
      configuration: { authUserPoolId: string | null; authUserPoolClientId: string | null; authUserPoolDomainURL: string | null } | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    office: {
      id: string;
      active: boolean;
      name: string;
      legalName: string | null;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
    } | null;
    employee: {
      id: string;
      _version: number | null;
      _deleted: boolean | null;
      _lastChangedAt: number | null;
      companyId: string;
      fullName: string | null;
      email: string | null;
      birthDate: string | null;
      hireDate: string | null;
      officeId: string | null;
      isPaused: boolean | null;
      active: boolean | null;
      externalId: string | null;
      firstName: string | null;
      preferredFirstName: string | null;
      lastName: string | null;
      phoneNumber: Array<string | null> | null;
      foodPreferences: string | null;
      deliveryMethod: Types.TDeliveryMethod | null;
      customOnboardBrick: string | null;
      tShirtSize: string | null;
      sweaterSize: string | null;
      donateBirthdayGift: boolean | null;
      donateWorkAnniversaryGift: boolean | null;
      pausePeriod: { fromDate: string; toDate: string | null } | null;
      address: {
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        address1: string | null;
        address2: string | null;
        city: string | null;
        state: string | null;
        country: string | null;
        zipCode: string | null;
        parent: string | null;
        parentType: Types.TAddressParentTypes | null;
        useGoogleAddress: boolean | null;
        googleValidated: boolean | null;
        missingInfo: boolean | null;
        alert: string | null;
        addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
      } | null;
      office: {
        id: string;
        active: boolean;
        name: string;
        legalName: string | null;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        _lastChangedAt: number | null;
        contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
        address: {
          id: string;
          companyId: string;
          _version: number;
          _deleted: boolean | null;
          address1: string | null;
          address2: string | null;
          city: string | null;
          state: string | null;
          country: string | null;
          zipCode: string | null;
          parent: string | null;
          parentType: Types.TAddressParentTypes | null;
          useGoogleAddress: boolean | null;
          googleValidated: boolean | null;
          missingInfo: boolean | null;
          alert: string | null;
          addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
        } | null;
      } | null;
    } | null;
    recipient:
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          employeeId: string;
          type: Types.TDependantType;
          petType: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          fullName: string | null;
          birthDate: string | null;
          foodPreferences: string | null;
          donateBirthdayGift: boolean | null;
          employee: {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          } | null;
        }
      | {
          id: string;
          _version: number | null;
          _deleted: boolean | null;
          _lastChangedAt: number | null;
          companyId: string;
          fullName: string | null;
          email: string | null;
          birthDate: string | null;
          hireDate: string | null;
          officeId: string | null;
          isPaused: boolean | null;
          active: boolean | null;
          externalId: string | null;
          firstName: string | null;
          preferredFirstName: string | null;
          lastName: string | null;
          phoneNumber: Array<string | null> | null;
          foodPreferences: string | null;
          deliveryMethod: Types.TDeliveryMethod | null;
          customOnboardBrick: string | null;
          tShirtSize: string | null;
          sweaterSize: string | null;
          donateBirthdayGift: boolean | null;
          donateWorkAnniversaryGift: boolean | null;
          pausePeriod: { fromDate: string; toDate: string | null } | null;
          address: {
            id: string;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            address1: string | null;
            address2: string | null;
            city: string | null;
            state: string | null;
            country: string | null;
            zipCode: string | null;
            parent: string | null;
            parentType: Types.TAddressParentTypes | null;
            useGoogleAddress: boolean | null;
            googleValidated: boolean | null;
            missingInfo: boolean | null;
            alert: string | null;
            addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
          } | null;
          office: {
            id: string;
            active: boolean;
            name: string;
            legalName: string | null;
            companyId: string;
            _version: number;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
          } | null;
        }
      | null;
    label: { carrier: string } | null;
    gifts: {
      nextToken: string | null;
      items: Array<{
        id: string;
        companyId: string;
        _version: number;
        _deleted: boolean | null;
        employeeId: string;
        status: Types.TGiftStatuses;
        notes: string | null;
        recipientData: string | null;
        type: Types.TGiftTypes;
        oneOffSource: string | null;
        brickColor: string | null;
        brickSize: string | null;
        brickQuantity: number | null;
        brickText: string | null;
        event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
        recipient:
          | {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              employeeId: string;
              type: Types.TDependantType;
              petType: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              fullName: string | null;
              birthDate: string | null;
              foodPreferences: string | null;
              donateBirthdayGift: boolean | null;
              employee: {
                id: string;
                _version: number | null;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                companyId: string;
                fullName: string | null;
                email: string | null;
                birthDate: string | null;
                hireDate: string | null;
                officeId: string | null;
                isPaused: boolean | null;
                active: boolean | null;
                externalId: string | null;
                firstName: string | null;
                preferredFirstName: string | null;
                lastName: string | null;
                phoneNumber: Array<string | null> | null;
                foodPreferences: string | null;
                deliveryMethod: Types.TDeliveryMethod | null;
                customOnboardBrick: string | null;
                tShirtSize: string | null;
                sweaterSize: string | null;
                donateBirthdayGift: boolean | null;
                donateWorkAnniversaryGift: boolean | null;
                pausePeriod: { fromDate: string; toDate: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
                office: {
                  id: string;
                  active: boolean;
                  name: string;
                  legalName: string | null;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  _lastChangedAt: number | null;
                  contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                  address: {
                    id: string;
                    companyId: string;
                    _version: number;
                    _deleted: boolean | null;
                    address1: string | null;
                    address2: string | null;
                    city: string | null;
                    state: string | null;
                    country: string | null;
                    zipCode: string | null;
                    parent: string | null;
                    parentType: Types.TAddressParentTypes | null;
                    useGoogleAddress: boolean | null;
                    googleValidated: boolean | null;
                    missingInfo: boolean | null;
                    alert: string | null;
                    addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                  } | null;
                } | null;
              } | null;
            }
          | {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            }
          | null;
      } | null>;
    } | null;
  } | null;
};

export type TOnCompanyShipmentRecreatedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyShipmentRecreatedSubscription = {
  onCompanyShipmentRecreated: {
    companyId: string;
    items: Array<{
      id: string;
      companyId: string;
      _version: number;
      _deleted: boolean | null;
      employeeId: string;
      status: Types.TGiftStatuses;
      notes: string | null;
      recipientData: string | null;
      type: Types.TGiftTypes;
      oneOffSource: string | null;
      brickColor: string | null;
      brickSize: string | null;
      brickQuantity: number | null;
      brickText: string | null;
      event: { age: number | null; eventDate: string; type: Types.TEventTypes; customType: string | null } | null;
      recipient:
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            employeeId: string;
            type: Types.TDependantType;
            petType: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            fullName: string | null;
            birthDate: string | null;
            foodPreferences: string | null;
            donateBirthdayGift: boolean | null;
            employee: {
              id: string;
              _version: number | null;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              companyId: string;
              fullName: string | null;
              email: string | null;
              birthDate: string | null;
              hireDate: string | null;
              officeId: string | null;
              isPaused: boolean | null;
              active: boolean | null;
              externalId: string | null;
              firstName: string | null;
              preferredFirstName: string | null;
              lastName: string | null;
              phoneNumber: Array<string | null> | null;
              foodPreferences: string | null;
              deliveryMethod: Types.TDeliveryMethod | null;
              customOnboardBrick: string | null;
              tShirtSize: string | null;
              sweaterSize: string | null;
              donateBirthdayGift: boolean | null;
              donateWorkAnniversaryGift: boolean | null;
              pausePeriod: { fromDate: string; toDate: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
              office: {
                id: string;
                active: boolean;
                name: string;
                legalName: string | null;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                _lastChangedAt: number | null;
                contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
                address: {
                  id: string;
                  companyId: string;
                  _version: number;
                  _deleted: boolean | null;
                  address1: string | null;
                  address2: string | null;
                  city: string | null;
                  state: string | null;
                  country: string | null;
                  zipCode: string | null;
                  parent: string | null;
                  parentType: Types.TAddressParentTypes | null;
                  useGoogleAddress: boolean | null;
                  googleValidated: boolean | null;
                  missingInfo: boolean | null;
                  alert: string | null;
                  addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
                } | null;
              } | null;
            } | null;
          }
        | {
            id: string;
            _version: number | null;
            _deleted: boolean | null;
            _lastChangedAt: number | null;
            companyId: string;
            fullName: string | null;
            email: string | null;
            birthDate: string | null;
            hireDate: string | null;
            officeId: string | null;
            isPaused: boolean | null;
            active: boolean | null;
            externalId: string | null;
            firstName: string | null;
            preferredFirstName: string | null;
            lastName: string | null;
            phoneNumber: Array<string | null> | null;
            foodPreferences: string | null;
            deliveryMethod: Types.TDeliveryMethod | null;
            customOnboardBrick: string | null;
            tShirtSize: string | null;
            sweaterSize: string | null;
            donateBirthdayGift: boolean | null;
            donateWorkAnniversaryGift: boolean | null;
            pausePeriod: { fromDate: string; toDate: string | null } | null;
            address: {
              id: string;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              address1: string | null;
              address2: string | null;
              city: string | null;
              state: string | null;
              country: string | null;
              zipCode: string | null;
              parent: string | null;
              parentType: Types.TAddressParentTypes | null;
              useGoogleAddress: boolean | null;
              googleValidated: boolean | null;
              missingInfo: boolean | null;
              alert: string | null;
              addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
            } | null;
            office: {
              id: string;
              active: boolean;
              name: string;
              legalName: string | null;
              companyId: string;
              _version: number;
              _deleted: boolean | null;
              _lastChangedAt: number | null;
              contact: { name: string | null; email: string | null; phoneNumber: string | null } | null;
              address: {
                id: string;
                companyId: string;
                _version: number;
                _deleted: boolean | null;
                address1: string | null;
                address2: string | null;
                city: string | null;
                state: string | null;
                country: string | null;
                zipCode: string | null;
                parent: string | null;
                parentType: Types.TAddressParentTypes | null;
                useGoogleAddress: boolean | null;
                googleValidated: boolean | null;
                missingInfo: boolean | null;
                alert: string | null;
                addressFromGoogle: { address1: string | null; address2: string | null; city: string | null; state: string | null; country: string | null; zipCode: string | null } | null;
              } | null;
            } | null;
          }
        | null;
    } | null>;
  } | null;
};

export type TUserFieldsFragment = { email: string; companyId: string; _version: number; _deleted: boolean | null; _lastChangedAt: number | null; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean };

export type TListUsersQueryVariables = Exact<{
  companyId: string;
  nextToken?: string | null | undefined;
  limit?: number | null | undefined;
  order?: Types.TOrderDirection | null | undefined;
}>;

export type TListUsersQuery = {
  listUsers: {
    nextToken: string | null;
    items: Array<{ email: string; companyId: string; _version: number; _deleted: boolean | null; _lastChangedAt: number | null; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean } | null>;
  };
};

export type TCreateUserMutationVariables = Exact<{
  input: Types.TCreateUserMutationInput;
}>;

export type TCreateUserMutation = {
  createUser: { email: string; companyId: string; _version: number; _deleted: boolean | null; _lastChangedAt: number | null; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean } | null;
};

export type TUpdateUserMutationVariables = Exact<{
  email: string;
  companyId: string;
  version: number;
  input: Types.TUpdateUserMutationInput;
}>;

export type TUpdateUserMutation = {
  updateUser: { email: string; companyId: string; _version: number; _deleted: boolean | null; _lastChangedAt: number | null; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean } | null;
};

export type TDeleteUserMutationVariables = Exact<{
  email: string;
  companyId: string;
  version: number;
}>;

export type TDeleteUserMutation = {
  deleteUser: { email: string; companyId: string; _version: number; _deleted: boolean | null; _lastChangedAt: number | null; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean } | null;
};

export type TTransferOwnershipMutationVariables = Exact<{
  oldOwnerEmail: string;
  _oldOwnerVersion: number;
  newOwnerEmail: string;
  companyId: string;
}>;

export type TTransferOwnershipMutation = {
  transferOwnership: Array<{ email: string; companyId: string; _version: number; _deleted: boolean | null; _lastChangedAt: number | null; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean } | null> | null;
};

export type TOnCompanyUserChangedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyUserChangedSubscription = {
  onCompanyUserChanged: { email: string; companyId: string; _version: number; _deleted: boolean | null; _lastChangedAt: number | null; name: string; type: Types.TUserType; title: string | null; isCompanyOwner: boolean } | null;
};

export type TOnCompanyOwnershipTransferedSubscriptionVariables = Exact<{
  companyId: string;
}>;

export type TOnCompanyOwnershipTransferedSubscription = {
  onCompanyOwnershipTransfered: Array<{
    email: string;
    companyId: string;
    _version: number;
    _deleted: boolean | null;
    _lastChangedAt: number | null;
    name: string;
    type: Types.TUserType;
    title: string | null;
    isCompanyOwner: boolean;
  } | null> | null;
};

export const PublicCompanyFieldsFragmentDoc = gql`
  fragment PublicCompanyFields on Company {
    id
    name
    subdomain
    configuration {
      authUserPoolId
      authUserPoolClientId
      authUserPoolDomainURL
    }
    googleLoginEnabled
    passwordLoginEnabled
  }
`;
export const DependantFieldsFragmentDoc = gql`
  fragment DependantFields on Dependant {
    id
    _version
    _deleted
    _lastChangedAt
    companyId
    employeeId
    type
    petType
    firstName
    preferredFirstName
    lastName
    fullName
    birthDate
    foodPreferences
    donateBirthdayGift
  }
`;
export const AddressFieldsFragmentDoc = gql`
  fragment AddressFields on Address {
    id
    companyId
    _version
    _deleted
    address1
    address2
    city
    state
    country
    zipCode
    parent
    parentType
    useGoogleAddress
    googleValidated
    missingInfo
    alert
    addressFromGoogle {
      address1
      address2
      city
      state
      country
      zipCode
    }
  }
`;
export const ContactFieldsFragmentDoc = gql`
  fragment ContactFields on Contact {
    name
    email
    phoneNumber
  }
`;
export const OfficeFieldsFragmentDoc = gql`
  fragment OfficeFields on Office {
    id
    active
    name
    legalName
    companyId
    _version
    _deleted
    _lastChangedAt
    contact {
      ...ContactFields
    }
    address {
      ...AddressFields
    }
  }
`;
export const EmployeeFieldsFragmentDoc = gql`
  fragment EmployeeFields on Employee {
    id
    _version
    _deleted
    _lastChangedAt
    companyId
    fullName
    email
    birthDate
    hireDate
    officeId
    isPaused
    pausePeriod {
      fromDate
      toDate
    }
    address {
      ...AddressFields
    }
    active
    externalId
    firstName
    preferredFirstName
    lastName
    phoneNumber
    foodPreferences
    deliveryMethod
    customOnboardBrick
    tShirtSize
    sweaterSize
    donateBirthdayGift
    donateWorkAnniversaryGift
    office {
      ...OfficeFields
    }
  }
`;
export const DependantFieldsHydratedFragmentDoc = gql`
  fragment DependantFieldsHydrated on Dependant {
    ...DependantFields
    employee {
      ...EmployeeFields
    }
  }
`;
export const RecipientFieldsFragmentDoc = gql`
  fragment RecipientFields on Recipient {
    ... on Dependant {
      ...DependantFieldsHydrated
    }
    ... on Employee {
      ...EmployeeFields
    }
  }
`;
export const EventFieldsFragmentDoc = gql`
  fragment EventFields on Event {
    id
    companyId
    eventDate
    type
    customType
    age
    oneOffSource
    brickQuantity
    brickSize
    brickColor
    brickText
    deliveredAt
    isPaused
    wasPaused
    notes
    employee {
      id
      companyId
      fullName
    }
    recipient {
      ...RecipientFields
    }
    _version
    _deleted
  }
`;
export const BasicGiftFieldsFragmentDoc = gql`
  fragment BasicGiftFields on Gift {
    id
    companyId
    _version
    _deleted
    employeeId
    status
    notes
    recipientData
    type
    oneOffSource
    brickColor
    brickSize
    brickQuantity
    brickText
  }
`;
export const GiftEventFieldsFragmentDoc = gql`
  fragment GiftEventFields on Event {
    age
    eventDate
    type
    customType
  }
`;
export const GiftFieldsFragmentDoc = gql`
  fragment GiftFields on Gift {
    ...BasicGiftFields
    event {
      ...GiftEventFields
    }
    recipient {
      ...RecipientFields
    }
  }
`;
export const CompanyFieldsFragmentDoc = gql`
  fragment CompanyFields on Company {
    id
    _version
    _deleted
    _lastChangedAt
    name
    accountManager
    active
    deliveryMethod
    subdomain
    configuration {
      authUserPoolId
      authUserPoolClientId
      authUserPoolDomainURL
    }
    emailDomains
    googleLoginEnabled
    swag
    legoActivated
    companyWideLegoCustomization
    customLego
    legoColor
    tissueColor
    signAs
    specialNote
    startDate
    endDate
    employeeBirthdayActivated
    employeeWorkAnniversaryActivated
    employeeNewHireKitActivated
    significantOtherBirthdayActivated
    childBirthdayActivated
    petBirthdayActivated
    hasCustomOnboardBrick
    workAnniversaryGiftVariation
    contact {
      ...ContactFields
    }
    address {
      ...AddressFields
    }
  }
`;
export const ShipmentFieldsFragmentDoc = gql`
  fragment ShipmentFields on Shipment {
    id
    companyId
    _deleted
    _version
    name
    status
    trackingNumber
    trackingURL
    actualShippingDate
    shippingDate
    notes
    addressTypeIcon
    readableAddressType
    recipientName
    label {
      carrier
    }
    gifts {
      nextToken
      items {
        ...GiftFields
      }
    }
  }
`;
export const GiftFieldsHydratedFragmentDoc = gql`
  fragment GiftFieldsHydrated on Gift {
    ...GiftFields
    company {
      ...CompanyFields
    }
    shipment {
      ...ShipmentFields
    }
    employee {
      ...EmployeeFields
    }
    address {
      ...AddressFields
    }
  }
`;
export const ShipmentFieldsHydratedFragmentDoc = gql`
  fragment ShipmentFieldsHydrated on Shipment {
    ...ShipmentFields
    address {
      ...AddressFields
      employee {
        ...EmployeeFields
      }
      office {
        ...OfficeFields
      }
      company {
        ...CompanyFields
      }
    }
    company {
      ...CompanyFields
    }
    office {
      ...OfficeFields
    }
    employee {
      ...EmployeeFields
    }
    recipient {
      ...RecipientFields
    }
  }
`;
export const UserFieldsFragmentDoc = gql`
  fragment UserFields on User {
    email
    companyId
    _version
    _deleted
    _lastChangedAt
    name
    type
    title
    isCompanyOwner
  }
`;
export const SkipAddressAlertDocument = gql`
  mutation SkipAddressAlert($id: ID!, $companyId: ID!, $version: Int!) {
    skipAddressAlert(id: $id, companyId: $companyId, _version: $version) {
      ...AddressFields
    }
  }
  ${AddressFieldsFragmentDoc}
`;
export type TSkipAddressAlertMutationFn = Apollo.MutationFunction<TSkipAddressAlertMutation, TSkipAddressAlertMutationVariables>;

/**
 * __useSkipAddressAlertMutation__
 *
 * To run a mutation, you first call `useSkipAddressAlertMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSkipAddressAlertMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [skipAddressAlertMutation, { data, loading, error }] = useSkipAddressAlertMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useSkipAddressAlertMutation(baseOptions?: Apollo.MutationHookOptions<TSkipAddressAlertMutation, TSkipAddressAlertMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TSkipAddressAlertMutation, TSkipAddressAlertMutationVariables>(SkipAddressAlertDocument, options);
}
export type SkipAddressAlertMutationHookResult = ReturnType<typeof useSkipAddressAlertMutation>;
export type SkipAddressAlertMutationResult = Apollo.MutationResult<TSkipAddressAlertMutation>;
export type SkipAddressAlertMutationOptions = Apollo.BaseMutationOptions<TSkipAddressAlertMutation, TSkipAddressAlertMutationVariables>;
export const GetMyCompanyDocument = gql`
  query GetMyCompany {
    getMyCompany {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useGetMyCompanyQuery__
 *
 * To run a query within a React component, call `useGetMyCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCompanyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCompanyQuery(baseOptions?: Apollo.QueryHookOptions<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>(GetMyCompanyDocument, options);
}
export function useGetMyCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>(GetMyCompanyDocument, options);
}
// @ts-ignore
export function useGetMyCompanySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>): Apollo.UseSuspenseQueryResult<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>;
export function useGetMyCompanySuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetMyCompanyQuery | undefined, TGetMyCompanyQueryVariables>;
export function useGetMyCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>(GetMyCompanyDocument, options);
}
export type GetMyCompanyQueryHookResult = ReturnType<typeof useGetMyCompanyQuery>;
export type GetMyCompanyLazyQueryHookResult = ReturnType<typeof useGetMyCompanyLazyQuery>;
export type GetMyCompanySuspenseQueryHookResult = ReturnType<typeof useGetMyCompanySuspenseQuery>;
export type GetMyCompanyQueryResult = Apollo.QueryResult<TGetMyCompanyQuery, TGetMyCompanyQueryVariables>;
export const GetCompanyBySubdomainDocument = gql`
  query GetCompanyBySubdomain($subdomain: String!) {
    getCompanyBySubdomain(subdomain: $subdomain) {
      ...PublicCompanyFields
    }
  }
  ${PublicCompanyFieldsFragmentDoc}
`;

/**
 * __useGetCompanyBySubdomainQuery__
 *
 * To run a query within a React component, call `useGetCompanyBySubdomainQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompanyBySubdomainQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompanyBySubdomainQuery({
 *   variables: {
 *      subdomain: // value for 'subdomain'
 *   },
 * });
 */
export function useGetCompanyBySubdomainQuery(
  baseOptions: Apollo.QueryHookOptions<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables> & ({ variables: TGetCompanyBySubdomainQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>(GetCompanyBySubdomainDocument, options);
}
export function useGetCompanyBySubdomainLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>(GetCompanyBySubdomainDocument, options);
}
// @ts-ignore
export function useGetCompanyBySubdomainSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>;
export function useGetCompanyBySubdomainSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetCompanyBySubdomainQuery | undefined, TGetCompanyBySubdomainQueryVariables>;
export function useGetCompanyBySubdomainSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>(GetCompanyBySubdomainDocument, options);
}
export type GetCompanyBySubdomainQueryHookResult = ReturnType<typeof useGetCompanyBySubdomainQuery>;
export type GetCompanyBySubdomainLazyQueryHookResult = ReturnType<typeof useGetCompanyBySubdomainLazyQuery>;
export type GetCompanyBySubdomainSuspenseQueryHookResult = ReturnType<typeof useGetCompanyBySubdomainSuspenseQuery>;
export type GetCompanyBySubdomainQueryResult = Apollo.QueryResult<TGetCompanyBySubdomainQuery, TGetCompanyBySubdomainQueryVariables>;
export const OnCompanyChangedDocument = gql`
  subscription OnCompanyChanged($id: ID!) {
    onCompanyChanged(id: $id) {
      ...CompanyFields
    }
  }
  ${CompanyFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useOnCompanyChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyChangedSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOnCompanyChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyChangedSubscription, TOnCompanyChangedSubscriptionVariables> & ({ variables: TOnCompanyChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyChangedSubscription, TOnCompanyChangedSubscriptionVariables>(OnCompanyChangedDocument, options);
}
export type OnCompanyChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyChangedSubscription>;
export type OnCompanyChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyChangedSubscription>;
export const RefreshCompanyEmployeeCountDocument = gql`
  mutation RefreshCompanyEmployeeCount($id: ID!) {
    refreshCompanyEmployeeCount(id: $id) {
      id
      _version
      employeeCount
    }
  }
`;
export type TRefreshCompanyEmployeeCountMutationFn = Apollo.MutationFunction<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>;

/**
 * __useRefreshCompanyEmployeeCountMutation__
 *
 * To run a mutation, you first call `useRefreshCompanyEmployeeCountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshCompanyEmployeeCountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshCompanyEmployeeCountMutation, { data, loading, error }] = useRefreshCompanyEmployeeCountMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRefreshCompanyEmployeeCountMutation(baseOptions?: Apollo.MutationHookOptions<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>(RefreshCompanyEmployeeCountDocument, options);
}
export type RefreshCompanyEmployeeCountMutationHookResult = ReturnType<typeof useRefreshCompanyEmployeeCountMutation>;
export type RefreshCompanyEmployeeCountMutationResult = Apollo.MutationResult<TRefreshCompanyEmployeeCountMutation>;
export type RefreshCompanyEmployeeCountMutationOptions = Apollo.BaseMutationOptions<TRefreshCompanyEmployeeCountMutation, TRefreshCompanyEmployeeCountMutationVariables>;
export const ListCompanyDependantsDocument = gql`
  query ListCompanyDependants($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listCompanyDependants(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...DependantFields
      }
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useListCompanyDependantsQuery__
 *
 * To run a query within a React component, call `useListCompanyDependantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyDependantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyDependantsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListCompanyDependantsQuery(
  baseOptions: Apollo.QueryHookOptions<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables> & ({ variables: TListCompanyDependantsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>(ListCompanyDependantsDocument, options);
}
export function useListCompanyDependantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>(ListCompanyDependantsDocument, options);
}
// @ts-ignore
export function useListCompanyDependantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>;
export function useListCompanyDependantsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyDependantsQuery | undefined, TListCompanyDependantsQueryVariables>;
export function useListCompanyDependantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>(ListCompanyDependantsDocument, options);
}
export type ListCompanyDependantsQueryHookResult = ReturnType<typeof useListCompanyDependantsQuery>;
export type ListCompanyDependantsLazyQueryHookResult = ReturnType<typeof useListCompanyDependantsLazyQuery>;
export type ListCompanyDependantsSuspenseQueryHookResult = ReturnType<typeof useListCompanyDependantsSuspenseQuery>;
export type ListCompanyDependantsQueryResult = Apollo.QueryResult<TListCompanyDependantsQuery, TListCompanyDependantsQueryVariables>;
export const ListEmployeeDependantsDocument = gql`
  query ListEmployeeDependants($companyId: ID!, $employeeId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listEmployeeDependants(companyId: $companyId, employeeId: $employeeId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...DependantFields
      }
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useListEmployeeDependantsQuery__
 *
 * To run a query within a React component, call `useListEmployeeDependantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeDependantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeDependantsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEmployeeDependantsQuery(
  baseOptions: Apollo.QueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables> & ({ variables: TListEmployeeDependantsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>(ListEmployeeDependantsDocument, options);
}
export function useListEmployeeDependantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>(ListEmployeeDependantsDocument, options);
}
// @ts-ignore
export function useListEmployeeDependantsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>;
export function useListEmployeeDependantsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeDependantsQuery | undefined, TListEmployeeDependantsQueryVariables>;
export function useListEmployeeDependantsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>(ListEmployeeDependantsDocument, options);
}
export type ListEmployeeDependantsQueryHookResult = ReturnType<typeof useListEmployeeDependantsQuery>;
export type ListEmployeeDependantsLazyQueryHookResult = ReturnType<typeof useListEmployeeDependantsLazyQuery>;
export type ListEmployeeDependantsSuspenseQueryHookResult = ReturnType<typeof useListEmployeeDependantsSuspenseQuery>;
export type ListEmployeeDependantsQueryResult = Apollo.QueryResult<TListEmployeeDependantsQuery, TListEmployeeDependantsQueryVariables>;
export const GetDependantDocument = gql`
  query GetDependant($id: ID!, $companyId: ID!) {
    getDependant(id: $id, companyId: $companyId) {
      ...DependantFields
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useGetDependantQuery__
 *
 * To run a query within a React component, call `useGetDependantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDependantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDependantQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetDependantQuery(baseOptions: Apollo.QueryHookOptions<TGetDependantQuery, TGetDependantQueryVariables> & ({ variables: TGetDependantQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetDependantQuery, TGetDependantQueryVariables>(GetDependantDocument, options);
}
export function useGetDependantLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetDependantQuery, TGetDependantQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetDependantQuery, TGetDependantQueryVariables>(GetDependantDocument, options);
}
// @ts-ignore
export function useGetDependantSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetDependantQuery, TGetDependantQueryVariables>): Apollo.UseSuspenseQueryResult<TGetDependantQuery, TGetDependantQueryVariables>;
export function useGetDependantSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetDependantQuery, TGetDependantQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetDependantQuery | undefined, TGetDependantQueryVariables>;
export function useGetDependantSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetDependantQuery, TGetDependantQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetDependantQuery, TGetDependantQueryVariables>(GetDependantDocument, options);
}
export type GetDependantQueryHookResult = ReturnType<typeof useGetDependantQuery>;
export type GetDependantLazyQueryHookResult = ReturnType<typeof useGetDependantLazyQuery>;
export type GetDependantSuspenseQueryHookResult = ReturnType<typeof useGetDependantSuspenseQuery>;
export type GetDependantQueryResult = Apollo.QueryResult<TGetDependantQuery, TGetDependantQueryVariables>;
export const CreateDependantDocument = gql`
  mutation CreateDependant($input: CreateDependantMutationInput!) {
    createDependant(input: $input) {
      ...DependantFields
    }
  }
  ${DependantFieldsFragmentDoc}
`;
export type TCreateDependantMutationFn = Apollo.MutationFunction<TCreateDependantMutation, TCreateDependantMutationVariables>;

/**
 * __useCreateDependantMutation__
 *
 * To run a mutation, you first call `useCreateDependantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDependantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDependantMutation, { data, loading, error }] = useCreateDependantMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDependantMutation(baseOptions?: Apollo.MutationHookOptions<TCreateDependantMutation, TCreateDependantMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateDependantMutation, TCreateDependantMutationVariables>(CreateDependantDocument, options);
}
export type CreateDependantMutationHookResult = ReturnType<typeof useCreateDependantMutation>;
export type CreateDependantMutationResult = Apollo.MutationResult<TCreateDependantMutation>;
export type CreateDependantMutationOptions = Apollo.BaseMutationOptions<TCreateDependantMutation, TCreateDependantMutationVariables>;
export const UpdateDependantDocument = gql`
  mutation UpdateDependant($id: ID!, $companyId: ID!, $version: Int!, $input: UpdateDependantMutationInput!) {
    updateDependant(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...DependantFields
    }
  }
  ${DependantFieldsFragmentDoc}
`;
export type TUpdateDependantMutationFn = Apollo.MutationFunction<TUpdateDependantMutation, TUpdateDependantMutationVariables>;

/**
 * __useUpdateDependantMutation__
 *
 * To run a mutation, you first call `useUpdateDependantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDependantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDependantMutation, { data, loading, error }] = useUpdateDependantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDependantMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateDependantMutation, TUpdateDependantMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateDependantMutation, TUpdateDependantMutationVariables>(UpdateDependantDocument, options);
}
export type UpdateDependantMutationHookResult = ReturnType<typeof useUpdateDependantMutation>;
export type UpdateDependantMutationResult = Apollo.MutationResult<TUpdateDependantMutation>;
export type UpdateDependantMutationOptions = Apollo.BaseMutationOptions<TUpdateDependantMutation, TUpdateDependantMutationVariables>;
export const DeleteDependantDocument = gql`
  mutation DeleteDependant($id: ID!, $companyId: ID!, $version: Int!) {
    deleteDependant(id: $id, companyId: $companyId, _version: $version) {
      ...DependantFields
    }
  }
  ${DependantFieldsFragmentDoc}
`;
export type TDeleteDependantMutationFn = Apollo.MutationFunction<TDeleteDependantMutation, TDeleteDependantMutationVariables>;

/**
 * __useDeleteDependantMutation__
 *
 * To run a mutation, you first call `useDeleteDependantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDependantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDependantMutation, { data, loading, error }] = useDeleteDependantMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteDependantMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteDependantMutation, TDeleteDependantMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteDependantMutation, TDeleteDependantMutationVariables>(DeleteDependantDocument, options);
}
export type DeleteDependantMutationHookResult = ReturnType<typeof useDeleteDependantMutation>;
export type DeleteDependantMutationResult = Apollo.MutationResult<TDeleteDependantMutation>;
export type DeleteDependantMutationOptions = Apollo.BaseMutationOptions<TDeleteDependantMutation, TDeleteDependantMutationVariables>;
export const OnCompanyDependantChangedDocument = gql`
  subscription OnCompanyDependantChanged($companyId: ID!) {
    onCompanyDependantChanged(companyId: $companyId) {
      ...DependantFields
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useOnCompanyDependantChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyDependantChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyDependantChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyDependantChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyDependantChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyDependantChangedSubscription, TOnCompanyDependantChangedSubscriptionVariables> & ({ variables: TOnCompanyDependantChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyDependantChangedSubscription, TOnCompanyDependantChangedSubscriptionVariables>(OnCompanyDependantChangedDocument, options);
}
export type OnCompanyDependantChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyDependantChangedSubscription>;
export type OnCompanyDependantChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyDependantChangedSubscription>;
export const OnEmployeeDependantChangedDocument = gql`
  subscription OnEmployeeDependantChanged($companyId: ID!, $employeeId: ID!) {
    onEmployeeDependantChanged(companyId: $companyId, employeeId: $employeeId) {
      ...DependantFields
    }
  }
  ${DependantFieldsFragmentDoc}
`;

/**
 * __useOnEmployeeDependantChangedSubscription__
 *
 * To run a query within a React component, call `useOnEmployeeDependantChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEmployeeDependantChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEmployeeDependantChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useOnEmployeeDependantChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnEmployeeDependantChangedSubscription, TOnEmployeeDependantChangedSubscriptionVariables> & ({ variables: TOnEmployeeDependantChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnEmployeeDependantChangedSubscription, TOnEmployeeDependantChangedSubscriptionVariables>(OnEmployeeDependantChangedDocument, options);
}
export type OnEmployeeDependantChangedSubscriptionHookResult = ReturnType<typeof useOnEmployeeDependantChangedSubscription>;
export type OnEmployeeDependantChangedSubscriptionResult = Apollo.SubscriptionResult<TOnEmployeeDependantChangedSubscription>;
export const ListCompanyEmployeesDocument = gql`
  query ListCompanyEmployees($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listCompanyEmployees(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) @connection(key: $companyId) {
      nextToken
      items {
        ...EmployeeFields
      }
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useListCompanyEmployeesQuery__
 *
 * To run a query within a React component, call `useListCompanyEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyEmployeesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListCompanyEmployeesQuery(baseOptions: Apollo.QueryHookOptions<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables> & ({ variables: TListCompanyEmployeesQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>(ListCompanyEmployeesDocument, options);
}
export function useListCompanyEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>(ListCompanyEmployeesDocument, options);
}
// @ts-ignore
export function useListCompanyEmployeesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>;
export function useListCompanyEmployeesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyEmployeesQuery | undefined, TListCompanyEmployeesQueryVariables>;
export function useListCompanyEmployeesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>(ListCompanyEmployeesDocument, options);
}
export type ListCompanyEmployeesQueryHookResult = ReturnType<typeof useListCompanyEmployeesQuery>;
export type ListCompanyEmployeesLazyQueryHookResult = ReturnType<typeof useListCompanyEmployeesLazyQuery>;
export type ListCompanyEmployeesSuspenseQueryHookResult = ReturnType<typeof useListCompanyEmployeesSuspenseQuery>;
export type ListCompanyEmployeesQueryResult = Apollo.QueryResult<TListCompanyEmployeesQuery, TListCompanyEmployeesQueryVariables>;
export const GetEmployeeDocument = gql`
  query GetEmployee($id: ID!, $companyId: ID!) {
    getEmployee(id: $id, companyId: $companyId) {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useGetEmployeeQuery__
 *
 * To run a query within a React component, call `useGetEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployeeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEmployeeQuery(baseOptions: Apollo.QueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables> & ({ variables: TGetEmployeeQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetEmployeeQuery, TGetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export function useGetEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetEmployeeQuery, TGetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
// @ts-ignore
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>): Apollo.UseSuspenseQueryResult<TGetEmployeeQuery, TGetEmployeeQueryVariables>;
export function useGetEmployeeSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetEmployeeQuery | undefined, TGetEmployeeQueryVariables>;
export function useGetEmployeeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEmployeeQuery, TGetEmployeeQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetEmployeeQuery, TGetEmployeeQueryVariables>(GetEmployeeDocument, options);
}
export type GetEmployeeQueryHookResult = ReturnType<typeof useGetEmployeeQuery>;
export type GetEmployeeLazyQueryHookResult = ReturnType<typeof useGetEmployeeLazyQuery>;
export type GetEmployeeSuspenseQueryHookResult = ReturnType<typeof useGetEmployeeSuspenseQuery>;
export type GetEmployeeQueryResult = Apollo.QueryResult<TGetEmployeeQuery, TGetEmployeeQueryVariables>;
export const CreateEmployeeDocument = gql`
  mutation CreateEmployee($input: CreateEmployeeMutationInput!) {
    createEmployee(input: $input) {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;
export type TCreateEmployeeMutationFn = Apollo.MutationFunction<TCreateEmployeeMutation, TCreateEmployeeMutationVariables>;

/**
 * __useCreateEmployeeMutation__
 *
 * To run a mutation, you first call `useCreateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmployeeMutation, { data, loading, error }] = useCreateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<TCreateEmployeeMutation, TCreateEmployeeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateEmployeeMutation, TCreateEmployeeMutationVariables>(CreateEmployeeDocument, options);
}
export type CreateEmployeeMutationHookResult = ReturnType<typeof useCreateEmployeeMutation>;
export type CreateEmployeeMutationResult = Apollo.MutationResult<TCreateEmployeeMutation>;
export type CreateEmployeeMutationOptions = Apollo.BaseMutationOptions<TCreateEmployeeMutation, TCreateEmployeeMutationVariables>;
export const UpdateEmployeeDocument = gql`
  mutation UpdateEmployee($id: ID!, $companyId: ID!, $version: Int!, $input: UpdateEmployeeMutationInput!) {
    updateEmployee(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;
export type TUpdateEmployeeMutationFn = Apollo.MutationFunction<TUpdateEmployeeMutation, TUpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateEmployeeMutation, TUpdateEmployeeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateEmployeeMutation, TUpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
}
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<TUpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<TUpdateEmployeeMutation, TUpdateEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
  mutation DeleteEmployee($id: ID!, $companyId: ID!, $version: Int!) {
    deleteEmployee(id: $id, companyId: $companyId, _version: $version) {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;
export type TDeleteEmployeeMutationFn = Apollo.MutationFunction<TDeleteEmployeeMutation, TDeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteEmployeeMutation, TDeleteEmployeeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteEmployeeMutation, TDeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
}
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<TDeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<TDeleteEmployeeMutation, TDeleteEmployeeMutationVariables>;
export const PauseEmployeeGiftsDocument = gql`
  mutation PauseEmployeeGifts($id: ID!, $companyId: ID!, $version: Int!, $fromDate: AWSDate, $toDate: AWSDate) {
    pauseEmployeeGifts(id: $id, companyId: $companyId, _version: $version, fromDate: $fromDate, toDate: $toDate) {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;
export type TPauseEmployeeGiftsMutationFn = Apollo.MutationFunction<TPauseEmployeeGiftsMutation, TPauseEmployeeGiftsMutationVariables>;

/**
 * __usePauseEmployeeGiftsMutation__
 *
 * To run a mutation, you first call `usePauseEmployeeGiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseEmployeeGiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseEmployeeGiftsMutation, { data, loading, error }] = usePauseEmployeeGiftsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      fromDate: // value for 'fromDate'
 *      toDate: // value for 'toDate'
 *   },
 * });
 */
export function usePauseEmployeeGiftsMutation(baseOptions?: Apollo.MutationHookOptions<TPauseEmployeeGiftsMutation, TPauseEmployeeGiftsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TPauseEmployeeGiftsMutation, TPauseEmployeeGiftsMutationVariables>(PauseEmployeeGiftsDocument, options);
}
export type PauseEmployeeGiftsMutationHookResult = ReturnType<typeof usePauseEmployeeGiftsMutation>;
export type PauseEmployeeGiftsMutationResult = Apollo.MutationResult<TPauseEmployeeGiftsMutation>;
export type PauseEmployeeGiftsMutationOptions = Apollo.BaseMutationOptions<TPauseEmployeeGiftsMutation, TPauseEmployeeGiftsMutationVariables>;
export const UnpauseEmployeeGiftsDocument = gql`
  mutation UnpauseEmployeeGifts($id: ID!, $companyId: ID!, $version: Int!) {
    unpauseEmployeeGifts(id: $id, companyId: $companyId, _version: $version) {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;
export type TUnpauseEmployeeGiftsMutationFn = Apollo.MutationFunction<TUnpauseEmployeeGiftsMutation, TUnpauseEmployeeGiftsMutationVariables>;

/**
 * __useUnpauseEmployeeGiftsMutation__
 *
 * To run a mutation, you first call `useUnpauseEmployeeGiftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnpauseEmployeeGiftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unpauseEmployeeGiftsMutation, { data, loading, error }] = useUnpauseEmployeeGiftsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUnpauseEmployeeGiftsMutation(baseOptions?: Apollo.MutationHookOptions<TUnpauseEmployeeGiftsMutation, TUnpauseEmployeeGiftsMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUnpauseEmployeeGiftsMutation, TUnpauseEmployeeGiftsMutationVariables>(UnpauseEmployeeGiftsDocument, options);
}
export type UnpauseEmployeeGiftsMutationHookResult = ReturnType<typeof useUnpauseEmployeeGiftsMutation>;
export type UnpauseEmployeeGiftsMutationResult = Apollo.MutationResult<TUnpauseEmployeeGiftsMutation>;
export type UnpauseEmployeeGiftsMutationOptions = Apollo.BaseMutationOptions<TUnpauseEmployeeGiftsMutation, TUnpauseEmployeeGiftsMutationVariables>;
export const OnCompanyEmployeeChangedDocument = gql`
  subscription OnCompanyEmployeeChanged($companyId: ID!) {
    onCompanyEmployeeChanged(companyId: $companyId) {
      ...EmployeeFields
    }
  }
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useOnCompanyEmployeeChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyEmployeeChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyEmployeeChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyEmployeeChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyEmployeeChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyEmployeeChangedSubscription, TOnCompanyEmployeeChangedSubscriptionVariables> & ({ variables: TOnCompanyEmployeeChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyEmployeeChangedSubscription, TOnCompanyEmployeeChangedSubscriptionVariables>(OnCompanyEmployeeChangedDocument, options);
}
export type OnCompanyEmployeeChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyEmployeeChangedSubscription>;
export type OnCompanyEmployeeChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyEmployeeChangedSubscription>;
export const ListCompanyUpcomingEventsDocument = gql`
  query ListCompanyUpcomingEvents($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listCompanyUpcomingEvents(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...EventFields
      }
    }
  }
  ${EventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useListCompanyUpcomingEventsQuery__
 *
 * To run a query within a React component, call `useListCompanyUpcomingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListCompanyUpcomingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListCompanyUpcomingEventsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListCompanyUpcomingEventsQuery(
  baseOptions: Apollo.QueryHookOptions<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables> & ({ variables: TListCompanyUpcomingEventsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>(ListCompanyUpcomingEventsDocument, options);
}
export function useListCompanyUpcomingEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>(ListCompanyUpcomingEventsDocument, options);
}
// @ts-ignore
export function useListCompanyUpcomingEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>;
export function useListCompanyUpcomingEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListCompanyUpcomingEventsQuery | undefined, TListCompanyUpcomingEventsQueryVariables>;
export function useListCompanyUpcomingEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>(ListCompanyUpcomingEventsDocument, options);
}
export type ListCompanyUpcomingEventsQueryHookResult = ReturnType<typeof useListCompanyUpcomingEventsQuery>;
export type ListCompanyUpcomingEventsLazyQueryHookResult = ReturnType<typeof useListCompanyUpcomingEventsLazyQuery>;
export type ListCompanyUpcomingEventsSuspenseQueryHookResult = ReturnType<typeof useListCompanyUpcomingEventsSuspenseQuery>;
export type ListCompanyUpcomingEventsQueryResult = Apollo.QueryResult<TListCompanyUpcomingEventsQuery, TListCompanyUpcomingEventsQueryVariables>;
export const GetEventDocument = gql`
  query GetEvent($id: ID!, $companyId: ID!) {
    getEvent(id: $id, companyId: $companyId) {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useGetEventQuery__
 *
 * To run a query within a React component, call `useGetEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetEventQuery(baseOptions: Apollo.QueryHookOptions<TGetEventQuery, TGetEventQueryVariables> & ({ variables: TGetEventQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetEventQuery, TGetEventQueryVariables>(GetEventDocument, options);
}
export function useGetEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetEventQuery, TGetEventQueryVariables>(GetEventDocument, options);
}
// @ts-ignore
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>): Apollo.UseSuspenseQueryResult<TGetEventQuery, TGetEventQueryVariables>;
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>): Apollo.UseSuspenseQueryResult<TGetEventQuery | undefined, TGetEventQueryVariables>;
export function useGetEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetEventQuery, TGetEventQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetEventQuery, TGetEventQueryVariables>(GetEventDocument, options);
}
export type GetEventQueryHookResult = ReturnType<typeof useGetEventQuery>;
export type GetEventLazyQueryHookResult = ReturnType<typeof useGetEventLazyQuery>;
export type GetEventSuspenseQueryHookResult = ReturnType<typeof useGetEventSuspenseQuery>;
export type GetEventQueryResult = Apollo.QueryResult<TGetEventQuery, TGetEventQueryVariables>;
export const ListClientOneOffEventsDocument = gql`
  query ListClientOneOffEvents($companyId: ID!, $eventPage: String!, $nextToken: String, $limit: Int, $includingLastDays: Int, $includingNextDays: Int, $filter: FilterInput, $order: OrderDirection, $isScan: Boolean) {
    listClientOneOffEvents(companyId: $companyId, eventPage: $eventPage, nextToken: $nextToken, limit: $limit, includingLastDays: $includingLastDays, includingNextDays: $includingNextDays, filter: $filter, order: $order, isScan: $isScan)
      @connection(key: $companyId) {
      nextToken
      items {
        ...EventFields
      }
    }
  }
  ${EventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useListClientOneOffEventsQuery__
 *
 * To run a query within a React component, call `useListClientOneOffEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListClientOneOffEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListClientOneOffEventsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      eventPage: // value for 'eventPage'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      includingLastDays: // value for 'includingLastDays'
 *      includingNextDays: // value for 'includingNextDays'
 *      filter: // value for 'filter'
 *      order: // value for 'order'
 *      isScan: // value for 'isScan'
 *   },
 * });
 */
export function useListClientOneOffEventsQuery(
  baseOptions: Apollo.QueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables> & ({ variables: TListClientOneOffEventsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>(ListClientOneOffEventsDocument, options);
}
export function useListClientOneOffEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>(ListClientOneOffEventsDocument, options);
}
// @ts-ignore
export function useListClientOneOffEventsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>;
export function useListClientOneOffEventsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListClientOneOffEventsQuery | undefined, TListClientOneOffEventsQueryVariables>;
export function useListClientOneOffEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>(ListClientOneOffEventsDocument, options);
}
export type ListClientOneOffEventsQueryHookResult = ReturnType<typeof useListClientOneOffEventsQuery>;
export type ListClientOneOffEventsLazyQueryHookResult = ReturnType<typeof useListClientOneOffEventsLazyQuery>;
export type ListClientOneOffEventsSuspenseQueryHookResult = ReturnType<typeof useListClientOneOffEventsSuspenseQuery>;
export type ListClientOneOffEventsQueryResult = Apollo.QueryResult<TListClientOneOffEventsQuery, TListClientOneOffEventsQueryVariables>;
export const CreateOneOffEventDocument = gql`
  mutation CreateOneOffEvent($input: AWSJSON!) {
    createOneOffEvent(input: $input) {
      status
      error
      message
      data
    }
  }
`;
export type TCreateOneOffEventMutationFn = Apollo.MutationFunction<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>;

/**
 * __useCreateOneOffEventMutation__
 *
 * To run a mutation, you first call `useCreateOneOffEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOneOffEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOneOffEventMutation, { data, loading, error }] = useCreateOneOffEventMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOneOffEventMutation(baseOptions?: Apollo.MutationHookOptions<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>(CreateOneOffEventDocument, options);
}
export type CreateOneOffEventMutationHookResult = ReturnType<typeof useCreateOneOffEventMutation>;
export type CreateOneOffEventMutationResult = Apollo.MutationResult<TCreateOneOffEventMutation>;
export type CreateOneOffEventMutationOptions = Apollo.BaseMutationOptions<TCreateOneOffEventMutation, TCreateOneOffEventMutationVariables>;
export const OnCompanyEventChangedDocument = gql`
  subscription onCompanyEventChanged($companyId: ID!) {
    onCompanyEventChanged(companyId: $companyId) {
      ...EventFields
    }
  }
  ${EventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useOnCompanyEventChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyEventChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyEventChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyEventChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyEventChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyEventChangedSubscription, TOnCompanyEventChangedSubscriptionVariables> & ({ variables: TOnCompanyEventChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyEventChangedSubscription, TOnCompanyEventChangedSubscriptionVariables>(OnCompanyEventChangedDocument, options);
}
export type OnCompanyEventChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyEventChangedSubscription>;
export type OnCompanyEventChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyEventChangedSubscription>;
export const ListEmployeeAndDependatsGiftsDocument = gql`
  query ListEmployeeAndDependatsGifts($employeeId: ID!, $companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listEmployeeAndDependatsGifts(employeeId: $employeeId, companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...GiftFieldsHydrated
      }
    }
  }
  ${GiftFieldsHydratedFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
`;

/**
 * __useListEmployeeAndDependatsGiftsQuery__
 *
 * To run a query within a React component, call `useListEmployeeAndDependatsGiftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListEmployeeAndDependatsGiftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListEmployeeAndDependatsGiftsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListEmployeeAndDependatsGiftsQuery(
  baseOptions: Apollo.QueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables> & ({ variables: TListEmployeeAndDependatsGiftsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>(ListEmployeeAndDependatsGiftsDocument, options);
}
export function useListEmployeeAndDependatsGiftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>(ListEmployeeAndDependatsGiftsDocument, options);
}
// @ts-ignore
export function useListEmployeeAndDependatsGiftsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>;
export function useListEmployeeAndDependatsGiftsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListEmployeeAndDependatsGiftsQuery | undefined, TListEmployeeAndDependatsGiftsQueryVariables>;
export function useListEmployeeAndDependatsGiftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>(ListEmployeeAndDependatsGiftsDocument, options);
}
export type ListEmployeeAndDependatsGiftsQueryHookResult = ReturnType<typeof useListEmployeeAndDependatsGiftsQuery>;
export type ListEmployeeAndDependatsGiftsLazyQueryHookResult = ReturnType<typeof useListEmployeeAndDependatsGiftsLazyQuery>;
export type ListEmployeeAndDependatsGiftsSuspenseQueryHookResult = ReturnType<typeof useListEmployeeAndDependatsGiftsSuspenseQuery>;
export type ListEmployeeAndDependatsGiftsQueryResult = Apollo.QueryResult<TListEmployeeAndDependatsGiftsQuery, TListEmployeeAndDependatsGiftsQueryVariables>;
export const GetGiftDocument = gql`
  query GetGift($id: ID!, $companyId: ID!) {
    getGift(id: $id, companyId: $companyId) {
      ...GiftFieldsHydrated
    }
  }
  ${GiftFieldsHydratedFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
`;

/**
 * __useGetGiftQuery__
 *
 * To run a query within a React component, call `useGetGiftQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGiftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGiftQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetGiftQuery(baseOptions: Apollo.QueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables> & ({ variables: TGetGiftQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetGiftQuery, TGetGiftQueryVariables>(GetGiftDocument, options);
}
export function useGetGiftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetGiftQuery, TGetGiftQueryVariables>(GetGiftDocument, options);
}
// @ts-ignore
export function useGetGiftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>): Apollo.UseSuspenseQueryResult<TGetGiftQuery, TGetGiftQueryVariables>;
export function useGetGiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>): Apollo.UseSuspenseQueryResult<TGetGiftQuery | undefined, TGetGiftQueryVariables>;
export function useGetGiftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetGiftQuery, TGetGiftQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetGiftQuery, TGetGiftQueryVariables>(GetGiftDocument, options);
}
export type GetGiftQueryHookResult = ReturnType<typeof useGetGiftQuery>;
export type GetGiftLazyQueryHookResult = ReturnType<typeof useGetGiftLazyQuery>;
export type GetGiftSuspenseQueryHookResult = ReturnType<typeof useGetGiftSuspenseQuery>;
export type GetGiftQueryResult = Apollo.QueryResult<TGetGiftQuery, TGetGiftQueryVariables>;
export const OnCompanyEventGiftCreatedDocument = gql`
  subscription OnCompanyEventGiftCreated($companyId: ID!) {
    onCompanyEventGiftCreated(companyId: $companyId) {
      gift {
        ...GiftFieldsHydrated
      }
    }
  }
  ${GiftFieldsHydratedFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
`;

/**
 * __useOnCompanyEventGiftCreatedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyEventGiftCreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyEventGiftCreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyEventGiftCreatedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyEventGiftCreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyEventGiftCreatedSubscription, TOnCompanyEventGiftCreatedSubscriptionVariables> & ({ variables: TOnCompanyEventGiftCreatedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyEventGiftCreatedSubscription, TOnCompanyEventGiftCreatedSubscriptionVariables>(OnCompanyEventGiftCreatedDocument, options);
}
export type OnCompanyEventGiftCreatedSubscriptionHookResult = ReturnType<typeof useOnCompanyEventGiftCreatedSubscription>;
export type OnCompanyEventGiftCreatedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyEventGiftCreatedSubscription>;
export const OnCompanyGiftRemovedFromGroupDocument = gql`
  subscription OnCompanyGiftRemovedFromGroup($companyId: ID!) {
    onCompanyGiftRemovedFromGroup(companyId: $companyId) {
      items {
        ...GiftFieldsHydrated
      }
    }
  }
  ${GiftFieldsHydratedFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
`;

/**
 * __useOnCompanyGiftRemovedFromGroupSubscription__
 *
 * To run a query within a React component, call `useOnCompanyGiftRemovedFromGroupSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyGiftRemovedFromGroupSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyGiftRemovedFromGroupSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyGiftRemovedFromGroupSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyGiftRemovedFromGroupSubscription, TOnCompanyGiftRemovedFromGroupSubscriptionVariables> &
    ({ variables: TOnCompanyGiftRemovedFromGroupSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyGiftRemovedFromGroupSubscription, TOnCompanyGiftRemovedFromGroupSubscriptionVariables>(OnCompanyGiftRemovedFromGroupDocument, options);
}
export type OnCompanyGiftRemovedFromGroupSubscriptionHookResult = ReturnType<typeof useOnCompanyGiftRemovedFromGroupSubscription>;
export type OnCompanyGiftRemovedFromGroupSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyGiftRemovedFromGroupSubscription>;
export const OnCompanyGiftChangedDocument = gql`
  subscription OnCompanyGiftChanged($companyId: ID!) {
    onCompanyGiftChanged(companyId: $companyId) {
      ...GiftFieldsHydrated
    }
  }
  ${GiftFieldsHydratedFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
`;

/**
 * __useOnCompanyGiftChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyGiftChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyGiftChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyGiftChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyGiftChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyGiftChangedSubscription, TOnCompanyGiftChangedSubscriptionVariables> & ({ variables: TOnCompanyGiftChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyGiftChangedSubscription, TOnCompanyGiftChangedSubscriptionVariables>(OnCompanyGiftChangedDocument, options);
}
export type OnCompanyGiftChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyGiftChangedSubscription>;
export type OnCompanyGiftChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyGiftChangedSubscription>;
export const OnEmployeeGiftChangedDocument = gql`
  subscription OnEmployeeGiftChanged($employeeId: ID!, $companyId: ID!) {
    onEmployeeGiftChanged(employeeId: $employeeId, companyId: $companyId) {
      ...GiftFieldsHydrated
    }
  }
  ${GiftFieldsHydratedFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
`;

/**
 * __useOnEmployeeGiftChangedSubscription__
 *
 * To run a query within a React component, call `useOnEmployeeGiftChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnEmployeeGiftChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnEmployeeGiftChangedSubscription({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnEmployeeGiftChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnEmployeeGiftChangedSubscription, TOnEmployeeGiftChangedSubscriptionVariables> & ({ variables: TOnEmployeeGiftChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnEmployeeGiftChangedSubscription, TOnEmployeeGiftChangedSubscriptionVariables>(OnEmployeeGiftChangedDocument, options);
}
export type OnEmployeeGiftChangedSubscriptionHookResult = ReturnType<typeof useOnEmployeeGiftChangedSubscription>;
export type OnEmployeeGiftChangedSubscriptionResult = Apollo.SubscriptionResult<TOnEmployeeGiftChangedSubscription>;
export const ListOfficesDocument = gql`
  query ListOffices($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listOffices(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...OfficeFields
      }
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useListOfficesQuery__
 *
 * To run a query within a React component, call `useListOfficesQuery` and pass it any options that fit your needs.
 * When your component renders, `useListOfficesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListOfficesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListOfficesQuery(baseOptions: Apollo.QueryHookOptions<TListOfficesQuery, TListOfficesQueryVariables> & ({ variables: TListOfficesQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListOfficesQuery, TListOfficesQueryVariables>(ListOfficesDocument, options);
}
export function useListOfficesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListOfficesQuery, TListOfficesQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListOfficesQuery, TListOfficesQueryVariables>(ListOfficesDocument, options);
}
// @ts-ignore
export function useListOfficesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListOfficesQuery, TListOfficesQueryVariables>): Apollo.UseSuspenseQueryResult<TListOfficesQuery, TListOfficesQueryVariables>;
export function useListOfficesSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOfficesQuery, TListOfficesQueryVariables>
): Apollo.UseSuspenseQueryResult<TListOfficesQuery | undefined, TListOfficesQueryVariables>;
export function useListOfficesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListOfficesQuery, TListOfficesQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListOfficesQuery, TListOfficesQueryVariables>(ListOfficesDocument, options);
}
export type ListOfficesQueryHookResult = ReturnType<typeof useListOfficesQuery>;
export type ListOfficesLazyQueryHookResult = ReturnType<typeof useListOfficesLazyQuery>;
export type ListOfficesSuspenseQueryHookResult = ReturnType<typeof useListOfficesSuspenseQuery>;
export type ListOfficesQueryResult = Apollo.QueryResult<TListOfficesQuery, TListOfficesQueryVariables>;
export const GetOfficeDocument = gql`
  query GetOffice($id: ID!, $companyId: ID!) {
    getOffice(id: $id, companyId: $companyId) {
      ...OfficeFields
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useGetOfficeQuery__
 *
 * To run a query within a React component, call `useGetOfficeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOfficeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOfficeQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetOfficeQuery(baseOptions: Apollo.QueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables> & ({ variables: TGetOfficeQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetOfficeQuery, TGetOfficeQueryVariables>(GetOfficeDocument, options);
}
export function useGetOfficeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetOfficeQuery, TGetOfficeQueryVariables>(GetOfficeDocument, options);
}
// @ts-ignore
export function useGetOfficeSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<TGetOfficeQuery, TGetOfficeQueryVariables>;
export function useGetOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>): Apollo.UseSuspenseQueryResult<TGetOfficeQuery | undefined, TGetOfficeQueryVariables>;
export function useGetOfficeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetOfficeQuery, TGetOfficeQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetOfficeQuery, TGetOfficeQueryVariables>(GetOfficeDocument, options);
}
export type GetOfficeQueryHookResult = ReturnType<typeof useGetOfficeQuery>;
export type GetOfficeLazyQueryHookResult = ReturnType<typeof useGetOfficeLazyQuery>;
export type GetOfficeSuspenseQueryHookResult = ReturnType<typeof useGetOfficeSuspenseQuery>;
export type GetOfficeQueryResult = Apollo.QueryResult<TGetOfficeQuery, TGetOfficeQueryVariables>;
export const CreateOfficeDocument = gql`
  mutation CreateOffice($input: CreateOfficeMutationInput!) {
    createOffice(input: $input) {
      ...OfficeFields
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TCreateOfficeMutationFn = Apollo.MutationFunction<TCreateOfficeMutation, TCreateOfficeMutationVariables>;

/**
 * __useCreateOfficeMutation__
 *
 * To run a mutation, you first call `useCreateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOfficeMutation, { data, loading, error }] = useCreateOfficeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<TCreateOfficeMutation, TCreateOfficeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateOfficeMutation, TCreateOfficeMutationVariables>(CreateOfficeDocument, options);
}
export type CreateOfficeMutationHookResult = ReturnType<typeof useCreateOfficeMutation>;
export type CreateOfficeMutationResult = Apollo.MutationResult<TCreateOfficeMutation>;
export type CreateOfficeMutationOptions = Apollo.BaseMutationOptions<TCreateOfficeMutation, TCreateOfficeMutationVariables>;
export const UpdateOfficeDocument = gql`
  mutation UpdateOffice($id: ID!, $companyId: ID!, $version: Int!, $input: UpdateOfficeMutationInput!) {
    updateOffice(id: $id, companyId: $companyId, _version: $version, input: $input) {
      ...OfficeFields
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TUpdateOfficeMutationFn = Apollo.MutationFunction<TUpdateOfficeMutation, TUpdateOfficeMutationVariables>;

/**
 * __useUpdateOfficeMutation__
 *
 * To run a mutation, you first call `useUpdateOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOfficeMutation, { data, loading, error }] = useUpdateOfficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOfficeMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateOfficeMutation, TUpdateOfficeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateOfficeMutation, TUpdateOfficeMutationVariables>(UpdateOfficeDocument, options);
}
export type UpdateOfficeMutationHookResult = ReturnType<typeof useUpdateOfficeMutation>;
export type UpdateOfficeMutationResult = Apollo.MutationResult<TUpdateOfficeMutation>;
export type UpdateOfficeMutationOptions = Apollo.BaseMutationOptions<TUpdateOfficeMutation, TUpdateOfficeMutationVariables>;
export const DeleteOfficeDocument = gql`
  mutation DeleteOffice($id: ID!, $companyId: ID!, $version: Int!) {
    deleteOffice(id: $id, companyId: $companyId, _version: $version) {
      ...OfficeFields
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;
export type TDeleteOfficeMutationFn = Apollo.MutationFunction<TDeleteOfficeMutation, TDeleteOfficeMutationVariables>;

/**
 * __useDeleteOfficeMutation__
 *
 * To run a mutation, you first call `useDeleteOfficeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOfficeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOfficeMutation, { data, loading, error }] = useDeleteOfficeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteOfficeMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteOfficeMutation, TDeleteOfficeMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteOfficeMutation, TDeleteOfficeMutationVariables>(DeleteOfficeDocument, options);
}
export type DeleteOfficeMutationHookResult = ReturnType<typeof useDeleteOfficeMutation>;
export type DeleteOfficeMutationResult = Apollo.MutationResult<TDeleteOfficeMutation>;
export type DeleteOfficeMutationOptions = Apollo.BaseMutationOptions<TDeleteOfficeMutation, TDeleteOfficeMutationVariables>;
export const OnCompanyOfficeChangedDocument = gql`
  subscription OnCompanyOfficeChanged($companyId: ID!) {
    onCompanyOfficeChanged(companyId: $companyId) {
      ...OfficeFields
    }
  }
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
`;

/**
 * __useOnCompanyOfficeChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyOfficeChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyOfficeChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyOfficeChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyOfficeChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyOfficeChangedSubscription, TOnCompanyOfficeChangedSubscriptionVariables> & ({ variables: TOnCompanyOfficeChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyOfficeChangedSubscription, TOnCompanyOfficeChangedSubscriptionVariables>(OnCompanyOfficeChangedDocument, options);
}
export type OnCompanyOfficeChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyOfficeChangedSubscription>;
export type OnCompanyOfficeChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyOfficeChangedSubscription>;
export const ListShipmentsDocument = gql`
  query ListShipments($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listCompanyShipments(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...ShipmentFieldsHydrated
      }
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
`;

/**
 * __useListShipmentsQuery__
 *
 * To run a query within a React component, call `useListShipmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListShipmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListShipmentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListShipmentsQuery(baseOptions: Apollo.QueryHookOptions<TListShipmentsQuery, TListShipmentsQueryVariables> & ({ variables: TListShipmentsQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListShipmentsQuery, TListShipmentsQueryVariables>(ListShipmentsDocument, options);
}
export function useListShipmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListShipmentsQuery, TListShipmentsQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListShipmentsQuery, TListShipmentsQueryVariables>(ListShipmentsDocument, options);
}
// @ts-ignore
export function useListShipmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListShipmentsQuery, TListShipmentsQueryVariables>): Apollo.UseSuspenseQueryResult<TListShipmentsQuery, TListShipmentsQueryVariables>;
export function useListShipmentsSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsQuery, TListShipmentsQueryVariables>
): Apollo.UseSuspenseQueryResult<TListShipmentsQuery | undefined, TListShipmentsQueryVariables>;
export function useListShipmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListShipmentsQuery, TListShipmentsQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListShipmentsQuery, TListShipmentsQueryVariables>(ListShipmentsDocument, options);
}
export type ListShipmentsQueryHookResult = ReturnType<typeof useListShipmentsQuery>;
export type ListShipmentsLazyQueryHookResult = ReturnType<typeof useListShipmentsLazyQuery>;
export type ListShipmentsSuspenseQueryHookResult = ReturnType<typeof useListShipmentsSuspenseQuery>;
export type ListShipmentsQueryResult = Apollo.QueryResult<TListShipmentsQuery, TListShipmentsQueryVariables>;
export const GetShipmentDocument = gql`
  query GetShipment($id: ID!, $companyId: ID!) {
    getShipment(id: $id, companyId: $companyId) {
      ...ShipmentFieldsHydrated
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
`;

/**
 * __useGetShipmentQuery__
 *
 * To run a query within a React component, call `useGetShipmentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetShipmentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetShipmentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetShipmentQuery(baseOptions: Apollo.QueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables> & ({ variables: TGetShipmentQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TGetShipmentQuery, TGetShipmentQueryVariables>(GetShipmentDocument, options);
}
export function useGetShipmentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TGetShipmentQuery, TGetShipmentQueryVariables>(GetShipmentDocument, options);
}
// @ts-ignore
export function useGetShipmentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>): Apollo.UseSuspenseQueryResult<TGetShipmentQuery, TGetShipmentQueryVariables>;
export function useGetShipmentSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>
): Apollo.UseSuspenseQueryResult<TGetShipmentQuery | undefined, TGetShipmentQueryVariables>;
export function useGetShipmentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TGetShipmentQuery, TGetShipmentQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TGetShipmentQuery, TGetShipmentQueryVariables>(GetShipmentDocument, options);
}
export type GetShipmentQueryHookResult = ReturnType<typeof useGetShipmentQuery>;
export type GetShipmentLazyQueryHookResult = ReturnType<typeof useGetShipmentLazyQuery>;
export type GetShipmentSuspenseQueryHookResult = ReturnType<typeof useGetShipmentSuspenseQuery>;
export type GetShipmentQueryResult = Apollo.QueryResult<TGetShipmentQuery, TGetShipmentQueryVariables>;
export const OnCompanyShipmentChangedDocument = gql`
  subscription OnCompanyShipmentChanged($companyId: ID!) {
    onCompanyShipmentChanged(companyId: $companyId) {
      ...ShipmentFieldsHydrated
    }
  }
  ${ShipmentFieldsHydratedFragmentDoc}
  ${ShipmentFieldsFragmentDoc}
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
  ${CompanyFieldsFragmentDoc}
`;

/**
 * __useOnCompanyShipmentChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyShipmentChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyShipmentChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyShipmentChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyShipmentChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyShipmentChangedSubscription, TOnCompanyShipmentChangedSubscriptionVariables> & ({ variables: TOnCompanyShipmentChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyShipmentChangedSubscription, TOnCompanyShipmentChangedSubscriptionVariables>(OnCompanyShipmentChangedDocument, options);
}
export type OnCompanyShipmentChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyShipmentChangedSubscription>;
export type OnCompanyShipmentChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyShipmentChangedSubscription>;
export const OnCompanyShipmentRecreatedDocument = gql`
  subscription OnCompanyShipmentRecreated($companyId: ID!) {
    onCompanyShipmentRecreated(companyId: $companyId) {
      companyId
      items {
        ...GiftFields
      }
    }
  }
  ${GiftFieldsFragmentDoc}
  ${BasicGiftFieldsFragmentDoc}
  ${GiftEventFieldsFragmentDoc}
  ${RecipientFieldsFragmentDoc}
  ${DependantFieldsHydratedFragmentDoc}
  ${DependantFieldsFragmentDoc}
  ${EmployeeFieldsFragmentDoc}
  ${AddressFieldsFragmentDoc}
  ${OfficeFieldsFragmentDoc}
  ${ContactFieldsFragmentDoc}
`;

/**
 * __useOnCompanyShipmentRecreatedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyShipmentRecreatedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyShipmentRecreatedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyShipmentRecreatedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyShipmentRecreatedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyShipmentRecreatedSubscription, TOnCompanyShipmentRecreatedSubscriptionVariables> & ({ variables: TOnCompanyShipmentRecreatedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyShipmentRecreatedSubscription, TOnCompanyShipmentRecreatedSubscriptionVariables>(OnCompanyShipmentRecreatedDocument, options);
}
export type OnCompanyShipmentRecreatedSubscriptionHookResult = ReturnType<typeof useOnCompanyShipmentRecreatedSubscription>;
export type OnCompanyShipmentRecreatedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyShipmentRecreatedSubscription>;
export const ListUsersDocument = gql`
  query ListUsers($companyId: ID!, $nextToken: String, $limit: Int, $order: OrderDirection) {
    listUsers(companyId: $companyId, nextToken: $nextToken, limit: $limit, order: $order) {
      nextToken
      items {
        ...UserFields
      }
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useListUsersQuery__
 *
 * To run a query within a React component, call `useListUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useListUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListUsersQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      nextToken: // value for 'nextToken'
 *      limit: // value for 'limit'
 *      order: // value for 'order'
 *   },
 * });
 */
export function useListUsersQuery(baseOptions: Apollo.QueryHookOptions<TListUsersQuery, TListUsersQueryVariables> & ({ variables: TListUsersQueryVariables; skip?: boolean } | { skip: boolean })) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<TListUsersQuery, TListUsersQueryVariables>(ListUsersDocument, options);
}
export function useListUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<TListUsersQuery, TListUsersQueryVariables>(ListUsersDocument, options);
}
// @ts-ignore
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>): Apollo.UseSuspenseQueryResult<TListUsersQuery, TListUsersQueryVariables>;
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>): Apollo.UseSuspenseQueryResult<TListUsersQuery | undefined, TListUsersQueryVariables>;
export function useListUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TListUsersQuery, TListUsersQueryVariables>) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<TListUsersQuery, TListUsersQueryVariables>(ListUsersDocument, options);
}
export type ListUsersQueryHookResult = ReturnType<typeof useListUsersQuery>;
export type ListUsersLazyQueryHookResult = ReturnType<typeof useListUsersLazyQuery>;
export type ListUsersSuspenseQueryHookResult = ReturnType<typeof useListUsersSuspenseQuery>;
export type ListUsersQueryResult = Apollo.QueryResult<TListUsersQuery, TListUsersQueryVariables>;
export const CreateUserDocument = gql`
  mutation CreateUser($input: CreateUserMutationInput!) {
    createUser(input: $input) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type TCreateUserMutationFn = Apollo.MutationFunction<TCreateUserMutation, TCreateUserMutationVariables>;

/**
 * __useCreateUserMutation__
 *
 * To run a mutation, you first call `useCreateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUserMutation, { data, loading, error }] = useCreateUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateUserMutation(baseOptions?: Apollo.MutationHookOptions<TCreateUserMutation, TCreateUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TCreateUserMutation, TCreateUserMutationVariables>(CreateUserDocument, options);
}
export type CreateUserMutationHookResult = ReturnType<typeof useCreateUserMutation>;
export type CreateUserMutationResult = Apollo.MutationResult<TCreateUserMutation>;
export type CreateUserMutationOptions = Apollo.BaseMutationOptions<TCreateUserMutation, TCreateUserMutationVariables>;
export const UpdateUserDocument = gql`
  mutation UpdateUser($email: AWSEmail!, $companyId: ID!, $version: Int!, $input: UpdateUserMutationInput!) {
    updateUser(email: $email, companyId: $companyId, _version: $version, input: $input) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type TUpdateUserMutationFn = Apollo.MutationFunction<TUpdateUserMutation, TUpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<TUpdateUserMutation, TUpdateUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TUpdateUserMutation, TUpdateUserMutationVariables>(UpdateUserDocument, options);
}
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<TUpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<TUpdateUserMutation, TUpdateUserMutationVariables>;
export const DeleteUserDocument = gql`
  mutation DeleteUser($email: AWSEmail!, $companyId: ID!, $version: Int!) {
    deleteUser(email: $email, companyId: $companyId, _version: $version) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type TDeleteUserMutationFn = Apollo.MutationFunction<TDeleteUserMutation, TDeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      email: // value for 'email'
 *      companyId: // value for 'companyId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<TDeleteUserMutation, TDeleteUserMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TDeleteUserMutation, TDeleteUserMutationVariables>(DeleteUserDocument, options);
}
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<TDeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<TDeleteUserMutation, TDeleteUserMutationVariables>;
export const TransferOwnershipDocument = gql`
  mutation TransferOwnership($oldOwnerEmail: AWSEmail!, $_oldOwnerVersion: Int!, $newOwnerEmail: AWSEmail!, $companyId: ID!) {
    transferOwnership(oldOwnerEmail: $oldOwnerEmail, _oldOwnerVersion: $_oldOwnerVersion, newOwnerEmail: $newOwnerEmail, companyId: $companyId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;
export type TTransferOwnershipMutationFn = Apollo.MutationFunction<TTransferOwnershipMutation, TTransferOwnershipMutationVariables>;

/**
 * __useTransferOwnershipMutation__
 *
 * To run a mutation, you first call `useTransferOwnershipMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTransferOwnershipMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [transferOwnershipMutation, { data, loading, error }] = useTransferOwnershipMutation({
 *   variables: {
 *      oldOwnerEmail: // value for 'oldOwnerEmail'
 *      _oldOwnerVersion: // value for '_oldOwnerVersion'
 *      newOwnerEmail: // value for 'newOwnerEmail'
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useTransferOwnershipMutation(baseOptions?: Apollo.MutationHookOptions<TTransferOwnershipMutation, TTransferOwnershipMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<TTransferOwnershipMutation, TTransferOwnershipMutationVariables>(TransferOwnershipDocument, options);
}
export type TransferOwnershipMutationHookResult = ReturnType<typeof useTransferOwnershipMutation>;
export type TransferOwnershipMutationResult = Apollo.MutationResult<TTransferOwnershipMutation>;
export type TransferOwnershipMutationOptions = Apollo.BaseMutationOptions<TTransferOwnershipMutation, TTransferOwnershipMutationVariables>;
export const OnCompanyUserChangedDocument = gql`
  subscription OnCompanyUserChanged($companyId: ID!) {
    onCompanyUserChanged(companyId: $companyId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useOnCompanyUserChangedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyUserChangedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyUserChangedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyUserChangedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyUserChangedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyUserChangedSubscription, TOnCompanyUserChangedSubscriptionVariables> & ({ variables: TOnCompanyUserChangedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyUserChangedSubscription, TOnCompanyUserChangedSubscriptionVariables>(OnCompanyUserChangedDocument, options);
}
export type OnCompanyUserChangedSubscriptionHookResult = ReturnType<typeof useOnCompanyUserChangedSubscription>;
export type OnCompanyUserChangedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyUserChangedSubscription>;
export const OnCompanyOwnershipTransferedDocument = gql`
  subscription OnCompanyOwnershipTransfered($companyId: ID!) {
    onCompanyOwnershipTransfered(companyId: $companyId) {
      ...UserFields
    }
  }
  ${UserFieldsFragmentDoc}
`;

/**
 * __useOnCompanyOwnershipTransferedSubscription__
 *
 * To run a query within a React component, call `useOnCompanyOwnershipTransferedSubscription` and pass it any options that fit your needs.
 * When your component renders, `useOnCompanyOwnershipTransferedSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnCompanyOwnershipTransferedSubscription({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useOnCompanyOwnershipTransferedSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<TOnCompanyOwnershipTransferedSubscription, TOnCompanyOwnershipTransferedSubscriptionVariables> &
    ({ variables: TOnCompanyOwnershipTransferedSubscriptionVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<TOnCompanyOwnershipTransferedSubscription, TOnCompanyOwnershipTransferedSubscriptionVariables>(OnCompanyOwnershipTransferedDocument, options);
}
export type OnCompanyOwnershipTransferedSubscriptionHookResult = ReturnType<typeof useOnCompanyOwnershipTransferedSubscription>;
export type OnCompanyOwnershipTransferedSubscriptionResult = Apollo.SubscriptionResult<TOnCompanyOwnershipTransferedSubscription>;
